// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file.
console.log("This site was developed by https://www.sleeplessmedia.com");
var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD' // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)

});

(function ($) {
  $(document).ready(function () {
    var homePackingSlider = new Swiper('.homePacking__sliderWrapper', {
      slidesPerView: 1,
      spaceBetween: 30,
      shortSwipes: false,
      threshold: 8,
      loop: false,
      navigation: {
        nextEl: '.homePacking__sliderNext',
        prevEl: '.homePacking__sliderPrev',
        disabledClass: 'homePacking__sliderButton--disabled'
      },
      breakpoints: {
        // when window width is >= 1000px
        1000: {
          slidesPerView: 3
        },
        700: {
          slidesPerView: 2
        }
      }
    });
    $('.homeHero__videoButton').on('click', function () {
      $('.homeVideo').fadeIn();
      // $('.homeVideo__modalInner').html($(this).attr('data-iframe'));
    });
    $('.homeVideo__overlay, .homeVideo__close').on('click', function () {
      $('.homeVideo').fadeOut();
      // $('.homeVideo__modalInner').html('');
    });
    $('.footerMobile__title').on('click', function () {
      var target = $(this).parent().find('.footerMobile__shelfRails');

      if ($(this).hasClass('footerMobile__title--active')) {
        $(this).removeClass('footerMobile__title--active');
        target.slideUp();
      } else {
        $(this).addClass('footerMobile__title--active');
        target.slideDown();
      }
    });
    var destinationNewsSlider = new Swiper('.destBlog__slideWrapper--news', {
      slidesPerView: 1,
      spaceBetween: 30,
      shortSwipes: false,
      threshold: 8,
      loop: true,
      navigation: {
        nextEl: '.destBlog__sliderNext--news',
        prevEl: '.destBlog__sliderPrev--news',
        disabledClass: 'destBlog__sliderButton--disabled'
      },
      breakpoints: {
        // when window width is >= 1000px
        1000: {
          slidesPerView: 4
        },
        800: {
          slidesPerView: 3
        },
        600: {
          slidesPerView: 2
        }
      }
    });
    var destinationBackstageSlider = new Swiper('.destBlog__slideWrapper--backstage', {
      slidesPerView: 1,
      spaceBetween: 30,
      shortSwipes: false,
      threshold: 8,
      loop: true,
      navigation: {
        nextEl: '.destBlog__sliderNext--backstage',
        prevEl: '.destBlog__sliderPrev--backstage',
        disabledClass: 'destBlog__sliderButton--disabled'
      },
      breakpoints: {
        // when window width is >= 1000px
        1000: {
          slidesPerView: 4
        },
        800: {
          slidesPerView: 3
        },
        600: {
          slidesPerView: 2
        }
      }
    });
    $('.destSidebar__button').on('click', function () {
      var index = $(this).attr('data-index');
      var target = $('.destRegion[data-index="' + index + '"]');

      if (!$(this).hasClass('destSidebar__button--active')) {
        $('.destSidebar__button').removeClass('destSidebar__button--active');
        $(this).addClass('destSidebar__button--active');
        $('.destRegion').slideUp();
        target.slideDown();
      }
    });
    $('.catToggleMob__option').on('click', function () {
      var index = $(this).attr('data-index');
      var target = $('.destRegion[data-index="' + index + '"]');
      $('.destRegion').slideUp();
      target.slideDown();
      $(this).attr('data-index', $('.catToggleMob__currentButton').attr('data-index'));
      $('.catToggleMob__currentButton').attr('data-index', index);
      var bufferText = $(this).text();
      $(this).text($('.catToggleMob__currentButton').find('.catToggleMob__currentText').text());
      $('.catToggleMob__currentButton').find('.catToggleMob__currentText').text(bufferText);
      $('.catToggleMob__optionsWrapper').slideUp();
      $('.catToggleMob__currentButton').removeClass('catToggleMob__currentButton--active');
    });
    $('.catToggleMob__currentButton').on('click', function () {
      if ($(this).hasClass('catToggleMob__currentButton--active')) {
        $(this).removeClass('catToggleMob__currentButton--active');
        $('.catToggleMob__optionsWrapper').slideUp();
      } else {
        $(this).addClass('catToggleMob__currentButton--active');
        $('.catToggleMob__optionsWrapper').slideDown();
      }
    });
    $('.destArticles__tab').on('click', function () {
      var tab = $(this).attr('data-tab');
      var target = $('.destBlog[data-tab="' + tab + '"]');

      if (!$(this).hasClass('destArticles__tab--active')) {
        $('.destArticles__tab').removeClass('destArticles__tab--active');
        $(this).addClass('destArticles__tab--active');
        $('.destBlog').slideUp();
        target.slideDown();
      }
    });
    $('.destArticles__accordionTitle').on('click', function () {
      var tab = $(this).attr('data-tab');

      if ($(this).hasClass('destArticles__accordionTitle--active')) {
        $(this).removeClass('destArticles__accordionTitle--active');
        $('.destBlog[data-tab="' + tab + '"]').slideUp();
      } else {
        $(this).addClass('destArticles__accordionTitle--active');
        $('.destBlog[data-tab="' + tab + '"]').slideDown();
      }
    });
    var lodgeSimilarSlider = new Swiper('.lodgeSimilar__slideWrapper', {
      slidesPerView: 1,
      spaceBetween: 30,
      shortSwipes: false,
      loop: true,
      threshold: 8,
      navigation: {
        nextEl: '.lodgeSimilar__sliderPrev',
        prevEl: '.lodgeSimilar__sliderNext',
        disabledClass: 'lodgeSimilar__sliderButton--disabled'
      },
      breakpoints: {
        // when window width is >= 1000px
        1000: {
          slidesPerView: 4
        },
        800: {
          slidesPerView: 3
        },
        600: {
          slidesPerView: 2
        }
      }
    });

    $(".lodgeVideoModal").detach().appendTo("body");
    
    $('.lodgeVideo__play').on('click', function () {
      $('.lodgeVideoModal').fadeIn();
      $('.lodgeVideoModal__iframeWrapper').html($(this).attr('data-iframe'));
      //$('main').removeClass('main--3d');
    });
    $('.lodgeVideoModal__close, .lodgeVideoModal__bkg').on('click', function () {
      $('.lodgeVideoModal').fadeOut();
      $('.lodgeVideoModal__iframeWrapper').html('');
      //$('main').addClass('main--3d');
    });
    $('.lodgeTabs__button').on('click', function () {
      if (!$(this).hasClass('lodgeTabs__button--active')) {
        var target = $('.lodgeTab[data-index="' + $(this).attr('data-index') + '"]');
        $('.lodgeTab').slideUp();
        target.slideDown();
        $('.lodgeTabs__button').removeClass('lodgeTabs__button--active');
        $(this).addClass('lodgeTabs__button--active');
      }
    });

    $(".lodgeGalleryModal").detach().appendTo("body");
    
    $('.lodgeGaller__play').on('click', function () {
      $('.lodgeGalleryModal').fadeIn();
      //$('main').removeClass('main--3d');
    });
    $('.lodgeGalleryModal__close, .lodgeGalleryModal__Background').on('click', function () {
      $('.lodgeGalleryModal').fadeOut();
      //$('main').addClass('main--3d');
    });
    var lodgeGallerySlider = new Swiper('.lodgeGalleryModal__slideshowWrapper', {
      slidesPerView: 1,
      shortSwipes: false,
      loop: true,
      threshold: 8,
      navigation: {
        nextEl: '.lodgeGalleryModal__sliderNext',
        prevEl: '.lodgeGalleryModal__sliderPrev',
        disabledClass: 'lodgeGalleryModal__sliderButton--disabled'
      }
    });
    $('.lodgeGallery__image').on('click', function () {
      var index = $(this).attr('data-index');
      lodgeGallerySlider.slideTo(index, 0, true);
      $('.lodgeGalleryModal').fadeIn();
    });
    $('.lodgeGalleryThumb').on('click', function () {
      var index = $(this).attr('data-index');
      lodgeGallerySlider.slideTo(index, 400, true);
    });
    $(document).on('click', 'a[href=""], a[aria-disabled="true"]', function (event) {
      event.preventDefault();
    });
    $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top + -60
      }, 1000);
    });
    $('.lodgeDesc__accordionButton').on('click', function () {
      if ($(this).hasClass('lodgeDesc__accordionButton--active')) {
        $('.lodgeDesc__accordionShelf').slideUp();
        $(this).removeClass('lodgeDesc__accordionButton--active');
      } else {
        $('.lodgeDesc__accordionShelf').slideDown();
        $(this).addClass('lodgeDesc__accordionButton--active');
      }
    });
    $('.lodgeTabs__accordionButton').on('click', function () {
      if ($(this).hasClass('lodgeDesc__accordionButton--active')) {
        $(this).parent().find('.llodgeTabs__accordionShelf').slideUp();
        $(this).removeClass('lodgeDesc__accordionButton--active');
      } else {
        $(this).parent().find('.llodgeTabs__accordionShelf').slideDown();
        $(this).addClass('lodgeDesc__accordionButton--active');
      }
    });
    var packingListSliderArray = Array($('.plCategory__sliderWrapper').length);
    $('.plCategory__sliderWrapper').each(function () {
      var index = $(this).attr('data-slider-index');
      console.log('creating slider for index of '+index);
      var targetSlider = '.plCategory__sliderWrapper--' + index;
      var targetNext = '.plCategory__sliderNext--' + index;
      var targetPrev = '.plCategory__sliderPrev--' + index;
      var targetScrollbar = '.plCategory__sliderScrollContainer--' + index;
      packingListSliderArray[index] = new Swiper(targetSlider, {
        slidesPerView: 1,
        shortSwipes: false,
        threshold: 8,
        freeMode: {
          enabled: true,
          sticky: true
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true
        },
        loop: false,
        spaceBetween: 30,
        navigation: {
          nextEl: targetNext,
          prevEl: targetPrev,
          disabledClass: 'plCategory__sliderButton--disabled'
        },
        scrollbar: {
          el: targetScrollbar,
          draggable: true
        },
        breakpoints: {
          // when window width is >= 1000px
          1001: {
            slidesPerView: 4,
            shortSwipes: false
          },
          1000: {
            slidesPerView: 3,
            shortSwipes: false
          },
          800: {
            slidesPerView: 2,
            shortSwipes: false
          }
        }
      });
      console.log(packingListSliderArray);
    });
    $('.plCategories__tab').on('click', function () {
      console.log('test');
      if (!$(this).hasClass('plCategories__tab--active')) {
        var target = $('.plCategory[data-index="' + $(this).attr('data-index') + '"]');
        $('.plCategory').slideUp();
        target.slideDown();
        $('.plCategories__tab').removeClass('plCategories__tab--active');
        $(this).addClass('plCategories__tab--active');
      }
    });
    $('.plCateogry__mobileAccordionButton').on('click', function () {
      var index = $(this).attr('data-index');
      var target = $('.plCategory[data-index="' + index + '"]');

      if ($(this).hasClass('plCateogry__mobileAccordionButton--active')) {
        $(this).removeClass('plCateogry__mobileAccordionButton--active');
        target.slideUp();
      } else {
        $(this).addClass('plCateogry__mobileAccordionButton--active');
        target.slideDown();
      }
    });
    var pdpDesktopThumbs = new Swiper('.prodGallery__desktopThumbnailsWrapper', {
      slidesPerView: 6,
      spaceBetween: 15,
      direction: "vertical",
      threshold: 15,
      loop: false,
      navigation: {
        nextEl: '.prodGallery__desktopThumbNextButton',
        prevEl: '.prodGallery__desktopThumbPrevButton',
        disabledClass: 'prodGallery__desktopThumbButton--disabled'
      }
    });
    var pdpMainSlider = new Swiper('.prodGallery__mainWrapper', {
      slidesPerView: 1,
      threshold: 8,
      loop: false
    });
    var pdpMobileThumbs = new Swiper('.prodGallery__mobileThumbnailsWrapper', {
      slidesPerView: 3,
      spaceBetween: 15,
      threshold: 15,
      loop: false
    });
    $('.prod__colorOption').each(function () {
      var thisColor = $(this).attr('data-color');
      var result = colorLib.filter(function (obj) {
        return obj.color === thisColor;
      });
      if (result.length > 0){
        $(this).find('.prod__colorOptionInner').attr('style', 'background:' + result[0].hex + ';');
      }
    });
    $('.prodGallery__desktopThumbClickable').on('click', function () {
      var index = $(this).attr('data-index');
      pdpMainSlider.slideTo(index, 200, true);
      $('.prodGallery__desktopThumbClickable').removeClass('prodGallery__desktopThumbClickable--active');
      $(this).addClass('prodGallery__desktopThumbClickable--active');
    });

    $('.prod__optionSelector').on('change', function () {
      var value = $(this).val();
      var index = $(this).attr('data-option');
      $('[sm-rc-option'+index+'-selector]').val(value).change();
      var imgSrc = $(this).find(":selected").attr('data-image');
      $('.prodGallery__desktopThumbImg[src="'+imgSrc+'"]').closest('button').click();
    });

    $('.prod__qtyPlus').on('click', function () {
      var qty = $(this).parent().find('[sm-rc-quantity-selector]').val() * 1;
      $(this).parent().find('[sm-rc-quantity-selector]').val(qty + 1);
    });
    $('.prod__qtyMinus').on('click', function () {
      var qty = $(this).parent().find('[sm-rc-quantity-selector]').val() * 1;

      if (qty > 1) {
        $(this).parent().find('[sm-rc-quantity-selector]').val(qty - 1);
      }
    });
    $('.prod__accordionTitleWrapper').on('click', function () {
      if ($(this).hasClass('prod__accordionTitleWrapper--active')) {
        $(this).parent().find('.prod__accordionFrame').slideUp();
        $(this).removeClass('prod__accordionTitleWrapper--active');
      } else {
        $(this).parent().find('.prod__accordionFrame').slideDown();
        $(this).addClass('prod__accordionTitleWrapper--active');
      }
    });
    $('.prodGallery__mobileThumbClickable').on('click', function () {
      var index = $(this).attr('data-index');
      pdpMainSlider.slideTo(index, 200, true);
      $('.prodGallery__mobileThumbClickable').removeClass('prodGallery__mobileThumbClickable--active');
      $(this).addClass('prodGallery__mobileThumbClickable--active');
    });
    $('.plProdCard__select').on('change', function () {
      var parent = $(this).closest('.plProdCard__inner');
      var fullStringArray = [];
      parent.find('.plProdCard__select').each(function () {
        fullStringArray.push($(this).val());
      });
      var fullString = fullStringArray.join(' / ');
      var target = parent.find('.plProdCard__hiddenSelector');
      parent.find('.plProdCard__hiddenSelector option').each(function () {
        if ($(this).text().trim() == fullString) {
          target.val($(this).val()).change();
        }
      });
    });
    $('.plProdCard__hiddenSelector').on('change', function(){
      var parent = $(this).closest('.plProdCard__inner');
      var selected = $(this).find(":selected");
      var image = selected.attr('data-image');
      var price = selected.attr('data-price');
      var available = selected.attr('data-available');

      console.log(image);
      console.log(image.indexOf("no-image"));
      if (image.indexOf("no-image") <= 0){
        parent.find('.plProdCard__img').attr('src', image);
      }
      parent.find('.plProdCard__price').text(price);
      if (available === "true"){
        parent.find('.plProdCard__buyWrapper').addClass('plProdCard__buyWrapper--active');
        parent.find('.plProdCard__soldOutWrapper').removeClass('plProdCard__soldOutWrapper--active');
      }
      else{
        parent.find('.plProdCard__buyWrapper').removeClass('plProdCard__buyWrapper--active');
        parent.find('.plProdCard__soldOutWrapper').addClass('plProdCard__soldOutWrapper--active');
      }
    });
    $('.plProdCard__addToCart').on('click', function () {
      var parent = $(this).closest('.plProdCard__inner');
      var target = parent.find('.plProdCard__hiddenSelector');
      var id = target.val() * 1;
      var qty = parent.find('.plProdCard__qty').attr('data-qty') * 1;
      console.log(id);
      console.log(qty);
      CartJS.addItem(id, qty, {
        "success": function success(data, textStatus, jqXHR) {
          var bufferCartSize = CartJS.cart.item_count;
          var checkCartSize = setInterval(function () {
            if (bufferCartSize != CartJS.cart.item_count) {
              clearInterval(checkCartSize);
              jQuery.getJSON('/cart.js', function (cart) {
                refreshMiniCart(cart, id, qty);
              });
            }
          }, 10);
        },
        "error": function error(jqXHR, textStatus, errorThrown) {
          console.log('Error: ' + errorThrown + '!');
        }
      });
    });
    $('.plProdCard__plus').on('click', function () {
      var qty = $(this).parent().find('.plProdCard__qty').attr('data-qty') * 1;
      $(this).parent().find('.plProdCard__qty').attr('data-qty', qty + 1);
      $(this).parent().find('.plProdCard__qty').text(qty + 1);
    });
    $('.plProdCard__minus').on('click', function () {
      var qty = $(this).parent().find('.plProdCard__qty').attr('data-qty') * 1;

      if (qty > 1) {
        $(this).parent().find('.plProdCard__qty').attr('data-qty', qty - 1);
        $(this).parent().find('.plProdCard__qty').text(qty - 1);
      }
    });
    var articleShopSlider = new Swiper('.articleShop__sliderWrapper', {
      slidesPerView: 1,
      spaceBetween: 30,
      threshold:15,
      loop: true,
      navigation: {
        nextEl: '.articleShop__sliderNext',
        prevEl: '.articleShop__sliderPrev',
        disabledClass: 'articleShop__sliderButton--disabled'
      },
      breakpoints: {
        // when window width is >= 1000px
        1000: {
          slidesPerView: 4
        },
        800: {
          slidesPerView: 3
        },
        600: {
          slidesPerView: 2
        }
      }
    });
    var articleRelatedSlider = new Swiper('.articleRelated__sliderWrapper', {
      slidesPerView: 1,
      spaceBetween: 30,
      shortSwipes: false,
      loop: true,
      navigation: {
        nextEl: '.articleRelated__sliderNext',
        prevEl: '.articleRelated__sliderPrev',
        disabledClass: 'articleRelated__sliderButton--disabled'
      },
      breakpoints: {
        // when window width is >= 1000px
        1000: {
          slidesPerView: 4
        },
        800: {
          slidesPerView: 3
        },
        600: {
          slidesPerView: 2
        }
      }
    });
    var conNewsSlider = new Swiper('.articleRelated__sliderWrapper--news', {
      slidesPerView: 1,
      spaceBetween: 30,
      shortSwipes: false,
      loop: true,
      navigation: {
        nextEl: '.articleRelated__sliderNext--news',
        prevEl: '.articleRelated__sliderPrev--news',
        disabledClass: 'articleRelated__sliderButton--disabled'
      },
      breakpoints: {
        // when window width is >= 1000px
        1000: {
          slidesPerView: 4
        },
        800: {
          slidesPerView: 3
        },
        600: {
          slidesPerView: 2
        }
      }
    });
    $('.blogSorting__blogInput--category').on('change', function () {
      var url = $(this).val();
      window.location.href = url;
    });
    $('.blogSorting__blogInput--tag').on('change', function () {
      var url = $(this).val();
      window.location.href = url;
    });
    var aboutTimelineSlider = new Swiper('.aboutTimeline__sliderWrapper', {
      slidesPerView: 1,
      spaceBetween: 30,
      shortSwipes: false,
      loop: true,
      navigation: {
        nextEl: '.timelineSlide__sliderNext',
        prevEl: '.timelineSlide__sliderPrev',
        disabledClass: 'timelineSlide__sliderButton--disabled'
      },
      breakpoints: {
        1000: {
          slidesPerView: 3
        },
        700: {
          slidesPerView: 2
        }
      }
    });
    var aboutGuidesSlider = new Swiper('.aboutGuides__sliderWrapper', {
      slidesPerView: 1,
      spaceBetween: 30,
      shortSwipes: false,
      loop: true,
      navigation: {
        nextEl: '.aboutGuides__sliderNext',
        prevEl: '.aboutGuides__sliderPrev',
        disabledClass: 'aboutGuides__sliderButton--disabled'
      },
      breakpoints: {
        // when window width is >= 1000px
        1000: {
          slidesPerView: 4
        },
        800: {
          slidesPerView: 3
        },
        600: {
          slidesPerView: 2
        }
      }
    });
    $('.aboutVideo__button').on('click', function () {
      $('.aboutVideoModal').fadeIn();
      $('.aboutVideoModal__iframeWrapper').html($(this).attr('data-iframe'));
    });
    $('.aboutVideoModal__bkg, .aboutVideoModal__close').on('click', function () {
      $('.aboutVideoModal').fadeOut();
      $('.aboutVideoModal__iframeWrapper').html('');
    });
    $('.teamSection__button').on('click', function () {
      if ($(this).hasClass('teamSection__button--active')) {
        return false;
      }

      var index = $(this).attr('data-index');
      $('.teamSection__button').removeClass('teamSection__button--active');
      $(this).addClass('teamSection__button--active');
      var target = $('.teamCat[data-index="' + index + '"]');
      $('.teamCat').slideUp();
      target.slideDown();
    });

    $(".teamPop").detach().appendTo("body");
    
    $('.teamMember, .homeTeamMember').on('click', function () {
      var thisThing = $(this);
      if (thisThing.hasClass('dayTrip')){
        var imgsrc = thisThing.attr('data-img');
        var name = thisThing.attr('data-title');
        var title = thisThing.attr('data-sub');
        var text = thisThing.attr('data-text');
        var email = thisThing.attr('data-href');
        $('.teamPop').find('.teamPop__img').attr('src', imgsrc);
        $('.teamPop').find('.teamPop__name').text(name);
        $('.teamPop').find('.teamPop__title').text(title);
        $('.teamPop').find('.teamPop__text').html(text);
        var $contact = $('.teamPop').find('.teamPop__contact');
        $contact.attr('href', email || '');
        if (email) {
          $contact.removeAttr('aria-disabled tabindex');
        } else {
          $contact.attr({'aria-disabled': 'true', 'tabindex': '-1'});
        }
      }
      else{
        var imgsrc = thisThing.attr('data-img');
        var name = thisThing.attr('data-name');
        var title = thisThing.attr('data-title');
        var text = thisThing.attr('data-text');
        var email = thisThing.attr('data-email');
        $('.teamPop').find('.teamPop__img').attr('src', imgsrc);
        $('.teamPop').find('.teamPop__name').text(name);
        $('.teamPop').find('.teamPop__title').text(title);
        $('.teamPop').find('.teamPop__text').html(text);
        var $contact = $('.teamPop').find('.teamPop__contact');
        $contact.attr('href', email || '');
        if (email) {
          $contact.removeAttr('aria-disabled tabindex');
        } else {
          $contact.attr({'aria-disabled': 'true', 'tabindex': '-1'});
        }
      }
      
      $('.teamPop').fadeIn();
      //$('main').removeClass('main--3d');
    });

    
    $('.teamPop__bkg, .teamPop__closeButton').on('click', function () {
      $('.teamPop').fadeOut();
      //$('main').addClass('main--3d');
    });

    
    $('.job__header').on('click', function () {
      if ($(this).hasClass('job__header--active')) {
        $('.job__shelf').slideUp();
        $('.job__header').removeClass('job__header--active');
      } else {
        $('.job__shelf').slideUp();
        $('.job__header').removeClass('job__header--active');
        $(this).addClass('job__header--active');
        $(this).parent().find('.job__shelf').slideDown();
      }
    });
    $('.destLodge__icon').hover(function () {
      console.log('mouseIn');
      var target = $(this).closest('.destLodge__linkWrapper').find('.destLodge__toolTip');
      var textSwap = $(this).attr('alt');
      target.find('div').text(textSwap);
      target.show();
    }, function () {
      console.log('mouseOut');
      var target = $(this).closest('.destLodge__linkWrapper').find('.destLodge__toolTip');
      target.hide();
    }); // MAIN CART

    $('.cart__quantityColumn, .cart__productMobileContainer').on('click', '.js-qty--cart', function (e) {
      e.preventDefault();
      var $this = $(this);
      var qtyInput = $this.closest('.qty').find('input');
      var qtyInputVal = qtyInput.val();
      qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
      var lineNum = $this.closest('.cart__productRow').attr('data-linenum');

      if ($this.hasClass('js-qty--plus')) {
        qtyInputVal++;
        qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
      } else {
        qtyInputVal--;
        qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
      }

      if (qtyInputVal >= 1) {
        console.log('got here');
        CartJS.updateItem(lineNum, qtyInputVal, {}, {
          success: function success(data, textStatus, jqXHR) {
            location.reload();
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            console.log(errorThrown);
          }
        });
      } else {
        CartJS.removeItem(lineNum, {
          success: function success(data, textStatus, jqXHR) {
            location.reload();
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            console.log(errorThrown);
          }
        });
      }
    }); // MAIN CART REMOVE

    $('.cart__productRemoveWrapper .remove-product').on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      var lineID = $this.closest('.cart__productRow').attr('data-lineid');
      CartJS.removeItemById(lineID, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {}
      });
    }); // WISHLIST FUNCTIONS

    function connectWishlistAccount() {
      window._swat.evtLayer.addEventListener(window._swat.JSEvents.customerInfoRefreshed, function (evt) {
        window._swat.authCheck(function (shopperContext) {});
      });

      if ($('.customer-logged-in').length) {
        window._swat.saveShopperContext($('.customer-logged-in').attr('customer-email'), {}, function () {
          console.log('wishlist context success');
        }, function () {
          console.log('error with wishlist context');
        });
      }
    }

    function addToWishList(variantID, productID, productURL, variantImage, price, stock, qty, vendor, title) {
      window._swat.addToWishList({
        "epi": variantID * 1,
        "du": productURL,
        "empi": productID * 1,
        "iu": variantImage,
        "pr": price,
        "et": 4,
        "stk": stock * 1,
        "qty": qty,
        "cprops": {
          "vendor": vendor,
          "title": title
        }
      }, function (r) {
        console.log(r);
        console.log('Added to wishlist');
        connectWishlistAccount();
        updateWishlistReady = true;
      });
    }

    function removeFromWishList(variantID, productID, productURL, variantImage, price, stock, qty, vendor, title) {
      window._swat.removeFromWishList({
        "epi": variantID * 1,
        "du": productURL,
        "empi": productID * 1,
        "iu": variantImage,
        "pr": price,
        "et": 4,
        "stk": stock * 1,
        "qty": qty,
        "cprops": {
          "vendor": vendor,
          "title": title
        }
      }, function (r) {
        console.log(r);
        console.log('Removed from wishlist');
        updateWishlistReady = true;
        connectWishlistAccount();
      });
    }

    function updateWishList(library, index, qty) {
      var translated = translateWishList(library);
      var variantID = translated[index].variant_id;
      var productID = translated[index].product_id;
      var productURL = translated[index].product_url;
      var variantImage = translated[index].variant_image;
      var price = translated[index].variant_price;
      var stock = translated[index].stock;
      var old_qty = translated[index].product_quantity;
      var new_qty = qty * 1;
      console.log(new_qty);

      window._swat.fetchLists({
        callbackFn: function callbackFn(lists) {
          var listID = lists[0].id;
          var listItemMap = {
            "epi": library[index].epi,
            "empi": library[index].empi,
            "du": library[index].du,
            "qty": new_qty
          };

          window._swat.updateListItem(listID, listItemMap, function (updatedListItem) {
            console.log('success');
            updateWishlistReady = true;
          }, function (xhrObj) {
            console.log(xhrObj);
          });
        },
        errorFn: function errorFn(xhrObj) {// something went wrong
        }
      });
    }

    function translateWishList(data) {
      if (typeof(data) !== "undefined" && data != false){
        var betterArray = [];

        for (i = 0; i < data.length; i++) {
          console.log(data[i]);
          var betterJSON = {
            "product_title": data[i].dt,
            "product_url": data[i].du,
            "product_id": data[i].empi,
            "variant_id": data[i].epi,
            "variant_image": data[i].iu,
            "variant_price": data[i].pr,
            "stock": data[i].stk,
            "product_quantity": data[i].qty,
            "other": data[i].cprops
          };
          betterArray.push(betterJSON);
        }
  
        return betterArray;
      }
      else{
        return false;
      }
    }

    function checkAgainstWishlist(wishlistData, productId) {
      var wishlist = translateWishList(wishlistData);
      var match = false;

      for (i = 0; i < wishlist.length; i++) {
        if (wishlist[i].product_id == productId) {
          match = true;
        } else {}
      }

      return match;
    }

    $('.plProdCard__favorite, .destLodge__favorite, .lodgeTitleRow__favorite').on('click', function (e) {
      e.preventDefault();

      if ($(this).hasClass('favorite--in')) {
        removeFromWishList($(this).attr('variant-id'), $(this).attr('product-id'), $(this).attr('product-url'), $(this).attr('variant-image'), $(this).attr('price'), $(this).attr('stock'), $(this).attr('qty').trim() * 1, $(this).attr('vendor'), $(this).attr('title'));
        $(this).removeClass('favorite--in');
      } else {
        addToWishList($(this).attr('variant-id'), $(this).attr('product-id'), $(this).attr('product-url'), $(this).attr('variant-image'), $(this).attr('price'), $(this).attr('stock'), $(this).attr('qty').trim() * 1, $(this).attr('vendor'), $(this).attr('title'));
        $(this).addClass('favorite--in');
      }
    });

    function swymCallbackFn(swat) {
      
      // Define error callback
      let onError = function(error) {
        // Error is an xhrObject
        console.log("Error while fetching all Lists", error);
      }
      
      // Call `fetchLists` function
      swat.fetchLists({
        callbackFn: function(lists){
          console.log("Fetched all Lists", lists);
            if (lists.length > 0){
              var r = lists[0].listcontents;
            }
            else{
              var r = false;
            }
            
            connectWishlistAccount();
            console.log(translateWishList(r));
            
            var updateWishlistReady = true;
            $('.plProdCard__favorite, .destLodge__favorite, .lodgeTitleRow__favorite').each(function () {
              var thisProdId = $(this).attr('product-id') * 1;

              if (checkAgainstWishlist(r, thisProdId)) {
                $(this).addClass('favorite--in');
              }
            });
          
              $('.plProdCard__favorite').each(function () {
                var thisProdId = $(this).attr('product-id') * 1;

                if (checkAgainstWishlist(r, thisProdId)) {
                  $(this).addClass('favorite--in');
                }

                var url = $('.collection__wrap').attr('data-shop');
                var currentUrl = $(this).attr('product-url');
                $(this).attr('product-url', url + currentUrl);
              });
              $('.plProdCard__favorite').on('click', function (e) {
                e.preventDefault();

                if ($(this).hasClass('favorite--in')) {
                  removeFromWishList($(this).attr('variant-id'), $(this).attr('product-id'), $(this).attr('product-url'), $(this).attr('variant-image'), $(this).attr('price'), $(this).attr('stock'), $(this).attr('qty').trim() * 1, $(this).attr('vendor'), $(this).attr('title'));
                  $(this).removeClass('favorite--in');
                } else {
                  addToWishList($(this).attr('variant-id'), $(this).attr('product-id'), $(this).attr('product-url'), $(this).attr('variant-image'), $(this).attr('price'), $(this).attr('stock'), $(this).attr('qty').trim() * 1, $(this).attr('vendor'), $(this).attr('title'));
                  $(this).addClass('favorite--in');
                }
              });
              console.log("Swym buttons loaded!");

            if ($('#shopify-section-wishlist').length >= 1) {
              var renderList = translateWishList(r);
              
              console.log('correct page');
              var bucket = $('.wishlist__bucket');
              var lodges = $('.wishlist__lodges');

              for (i = 0; i < renderList.length; i++) {
                if (renderList[i].other.vendor != 'lodge') {
                  var card = '';
                  card += '<div class="planCard" data-iteration="' + i + '">';
                  card += '<div class="planCard__inner">';
                  card += '<a class="planCard__imageWrapper" href="' + renderList[i].product_url + '">';
                  card += '<img class="planCard__image" src="' + renderList[i].variant_image + '" alt="' + renderList[i].product_title + '">';
                  card += '</a>';
                  card += '<div class="planCard__titleWrapper">';
                  card += '<a class="planCard__title" href="' + renderList[i].product_url + '">';
                  card += renderList[i].other.title;
                  card += '</a>';
                  card += '</div>';
                  card += '<div class="planCard__buttonWrapper">';
                  card += '<div class="planCard__qtyWrapper">';
                  card += '<button class="planCard__qtyMinus">-</button>';
                  card += '<div class="planCard__qty">';
                  card += renderList[i].product_quantity;
                  card += '</div>';
                  card += '<button class="planCard__qtyPlus">+</button>';
                  card += '</div>';
                  card += '<button class="planCard__addToCart" data-id="' + renderList[i].variant_id + '">';
                  card += 'Add To Cart';
                  card += '</button>';
                  card += '<a class="planCard__goToCart" href="/cart" style="display:none;">';
                  card += 'View In Cart';
                  card += '</a>';
                  card += '<button class="planCard__remove">';
                  card += '<img class="planCard__removeIcon" src="https://cdn.shopify.com/s/files/1/1586/7217/files/Union.png?v=1648318578" alt="remove icon">';
                  card += '</button>';
                  card += '</div>';
                  card += '</div>';
                  card += '</div>';
                  bucket.html(bucket.html() + card);
                } else {
                  var card = '';
                  card += '<div class="planCard" data-iteration="' + i + '">';
                  card += '<div class="planCard__inner">';
                  card += '<a class="planCard__imageWrapper" href="' + renderList[i].product_url + '">';
                  card += '<img class="planCard__image" src="' + renderList[i].variant_image + '" alt="' + renderList[i].product_title + '">';
                  card += '</a>';
                  card += '<div class="planCard__titleWrapper">';
                  card += '<a class="planCard__title" href="' + renderList[i].product_url + '">';
                  card += renderList[i].other.title;
                  card += '</a>';
                  card += '</div>';
                  card += '<div class="planCard__buttonWrapper">';
                  card += '<button class="planCard__remove">';
                  card += '<img class="planCard__removeIcon" src="https://cdn.shopify.com/s/files/1/1586/7217/files/Union.png?v=1648318578" alt="remove icon">';
                  card += '</button>';
                  card += '</div>';
                  card += '</div>';
                  card += '</div>';
                  lodges.html(lodges.html() + card);
                }
              } // button binds here


              $('.planCard__qtyMinus').on('click', function () {
                if (updateWishlistReady == true) {
                  var index = $(this).parent().parent().parent().parent().attr('data-iteration');
                  var currentQty = $(this).parent().find('.planCard__qty').text().trim() * 1;

                  if (currentQty > 1) {
                    updateWishlistReady = false;
                    var newQty = currentQty - 1;
                    $(this).parent().find('.planCard__qty').text(newQty);
                    updateWishList(r, index, newQty);
                  }
                }
              });
              $('.planCard__qtyPlus').on('click', function () {
                if (updateWishlistReady == true) {
                  var index = $(this).parent().parent().parent().parent().attr('data-iteration');
                  var currentQty = $(this).parent().find('.planCard__qty').text().trim() * 1;
                  updateWishlistReady = false;
                  var newQty = currentQty + 1;
                  $(this).parent().find('.planCard__qty').text(newQty);
                  updateWishList(r, index, newQty);
                }
              });
              $('.planCard__remove').on('click', function () {
                var index = $(this).parent().parent().parent().attr('data-iteration') * 1;
                var currentQty = $(this).parent().find('.planCard__qty').text().trim() * 1;
                updateWishlistReady = false;
                var variantID = renderList[index].variant_id;
                var productID = renderList[index].product_id;
                var productURL = renderList[index].product_url;
                var variantImage = renderList[index].variant_image;
                var price = renderList[index].variant_price;
                var stock = renderList[index].stock;
                var qty = renderList[index].product_quantity;
                removeFromWishList(variantID, productID, productURL, variantImage, price, stock, qty);
                $(this).parent().parent().parent().slideUp();
                connectWishlistAccount();
              });
              $('.planCard').each(function () {
                var variantId = $(this).find('.planCard__addToCart').attr('data-id') * 1;

                for (i = 0; i < CartJS.cart.items.length; i++) {
                  if (CartJS.cart.items[i].variant_id == variantId) {
                    $(this).find('.planCard__addToCart').hide();
                    $(this).find('.planCard__remove').hide();
                    $(this).find('.planCard__goToCart').show();
                  }
                }
              });
              $('.planCard__addToCart').on('click', function () {
                var variantId = $(this).attr('data-id') * 1;
                CartJS.addItem(variantId, 1, {}, {
                  "success": function success(data, textStatus, jqXHR) {
                    console.log('Product added to cart successfully');
                    updateCartBubble();
                  },
                  "error": function error(jqXHR, textStatus, errorThrown) {
                    console.log('Error: ' + errorThrown + '!');
                  }
                });
                $(this).parent().find('.planCard__addToCart').hide();
                $(this).parent().find('.planCard__remove').hide();
                $(this).parent().find('.planCard__goToCart').show();
              });
            }
        },
        errorFn: onError
      });
      
      /* var timeoutCounter = 0;
      var wishlistLoaded = setInterval(function () {
        console.log('wishlist not loaded');
        window._swat.fetch(function (r) {
          if (r.length > 0) {
            clearInterval(wishlistLoaded);
            console.log(r);
            console.log(translateWishList(r));
            connectWishlistAccount();
            var renderList = translateWishList(r);
            var updateWishlistReady = true;
            $('.plProdCard__favorite, .destLodge__favorite, .lodgeTitleRow__favorite').each(function () {
              var thisProdId = $(this).attr('product-id') * 1;

              if (checkAgainstWishlist(r, thisProdId)) {
                $(this).addClass('favorite--in');
              }
            });
            document.addEventListener("swym:collections-loaded", function () {
              $('.plProdCard__favorite').each(function () {
                var thisProdId = $(this).attr('product-id') * 1;

                if (checkAgainstWishlist(r, thisProdId)) {
                  $(this).addClass('favorite--in');
                }

                var url = $('.collection__wrap').attr('data-shop');
                var currentUrl = $(this).attr('product-url');
                $(this).attr('product-url', url + currentUrl);
              });
              $('.plProdCard__favorite').on('click', function (e) {
                e.preventDefault();

                if ($(this).hasClass('favorite--in')) {
                  removeFromWishList($(this).attr('variant-id'), $(this).attr('product-id'), $(this).attr('product-url'), $(this).attr('variant-image'), $(this).attr('price'), $(this).attr('stock'), $(this).attr('qty').trim() * 1, $(this).attr('vendor'), $(this).attr('title'));
                  $(this).removeClass('favorite--in');
                } else {
                  addToWishList($(this).attr('variant-id'), $(this).attr('product-id'), $(this).attr('product-url'), $(this).attr('variant-image'), $(this).attr('price'), $(this).attr('stock'), $(this).attr('qty').trim() * 1, $(this).attr('vendor'), $(this).attr('title'));
                  $(this).addClass('favorite--in');
                }
              });
              console.log("Swym buttons loaded!");
            });

            if ($('#shopify-section-wishlist').length >= 1) {
              console.log('correct page');
              var bucket = $('.wishlist__bucket');
              var lodges = $('.wishlist__lodges');

              for (i = 0; i < renderList.length; i++) {
                if (renderList[i].other.vendor != 'lodge') {
                  var card = '';
                  card += '<div class="planCard" data-iteration="' + i + '">';
                  card += '<div class="planCard__inner">';
                  card += '<a class="planCard__imageWrapper" href="' + renderList[i].product_url + '">';
                  card += '<img class="planCard__image" src="' + renderList[i].variant_image + '" alt="' + renderList[i].product_title + '">';
                  card += '</a>';
                  card += '<div class="planCard__titleWrapper">';
                  card += '<a class="planCard__title" href="' + renderList[i].product_url + '">';
                  card += renderList[i].other.title;
                  card += '</a>';
                  card += '</div>';
                  card += '<div class="planCard__buttonWrapper">';
                  card += '<div class="planCard__qtyWrapper">';
                  card += '<button class="planCard__qtyMinus">-</button>';
                  card += '<div class="planCard__qty">';
                  card += renderList[i].product_quantity;
                  card += '</div>';
                  card += '<button class="planCard__qtyPlus">+</button>';
                  card += '</div>';
                  card += '<button class="planCard__addToCart" data-id="' + renderList[i].variant_id + '">';
                  card += 'Add To Cart';
                  card += '</button>';
                  card += '<a class="planCard__goToCart" href="/cart" style="display:none;">';
                  card += 'View In Cart';
                  card += '</a>';
                  card += '<button class="planCard__remove">';
                  card += '<img class="planCard__removeIcon" src="https://cdn.shopify.com/s/files/1/1586/7217/files/Union.png?v=1648318578" alt="remove icon">';
                  card += '</button>';
                  card += '</div>';
                  card += '</div>';
                  card += '</div>';
                  bucket.html(bucket.html() + card);
                } else {
                  var card = '';
                  card += '<div class="planCard" data-iteration="' + i + '">';
                  card += '<div class="planCard__inner">';
                  card += '<a class="planCard__imageWrapper" href="' + renderList[i].product_url + '">';
                  card += '<img class="planCard__image" src="' + renderList[i].variant_image + '" alt="' + renderList[i].product_title + '">';
                  card += '</a>';
                  card += '<div class="planCard__titleWrapper">';
                  card += '<a class="planCard__title" href="' + renderList[i].product_url + '">';
                  card += renderList[i].other.title;
                  card += '</a>';
                  card += '</div>';
                  card += '<div class="planCard__buttonWrapper">';
                  card += '<button class="planCard__remove">';
                  card += '<img class="planCard__removeIcon" src="https://cdn.shopify.com/s/files/1/1586/7217/files/Union.png?v=1648318578" alt="remove icon">';
                  card += '</button>';
                  card += '</div>';
                  card += '</div>';
                  card += '</div>';
                  lodges.html(lodges.html() + card);
                }
              } // button binds here


              $('.planCard__qtyMinus').on('click', function () {
                if (updateWishlistReady == true) {
                  var index = $(this).parent().parent().parent().parent().attr('data-iteration');
                  var currentQty = $(this).parent().find('.planCard__qty').text().trim() * 1;

                  if (currentQty > 1) {
                    updateWishlistReady = false;
                    var newQty = currentQty - 1;
                    $(this).parent().find('.planCard__qty').text(newQty);
                    updateWishList(r, index, newQty);
                  }
                }
              });
              $('.planCard__qtyPlus').on('click', function () {
                if (updateWishlistReady == true) {
                  var index = $(this).parent().parent().parent().parent().attr('data-iteration');
                  var currentQty = $(this).parent().find('.planCard__qty').text().trim() * 1;
                  updateWishlistReady = false;
                  var newQty = currentQty + 1;
                  $(this).parent().find('.planCard__qty').text(newQty);
                  updateWishList(r, index, newQty);
                }
              });
              $('.planCard__remove').on('click', function () {
                var index = $(this).parent().parent().parent().attr('data-iteration') * 1;
                var currentQty = $(this).parent().find('.planCard__qty').text().trim() * 1;
                updateWishlistReady = false;
                var variantID = renderList[index].variant_id;
                var productID = renderList[index].product_id;
                var productURL = renderList[index].product_url;
                var variantImage = renderList[index].variant_image;
                var price = renderList[index].variant_price;
                var stock = renderList[index].stock;
                var qty = renderList[index].product_quantity;
                removeFromWishList(variantID, productID, productURL, variantImage, price, stock, qty);
                $(this).parent().parent().parent().slideUp();
                connectWishlistAccount();
              });
              $('.planCard').each(function () {
                var variantId = $(this).find('.planCard__addToCart').attr('data-id') * 1;

                for (i = 0; i < CartJS.cart.items.length; i++) {
                  if (CartJS.cart.items[i].variant_id == variantId) {
                    $(this).find('.planCard__addToCart').hide();
                    $(this).find('.planCard__remove').hide();
                    $(this).find('.planCard__goToCart').show();
                  }
                }
              });
              $('.planCard__addToCart').on('click', function () {
                var variantId = $(this).attr('data-id') * 1;
                CartJS.addItem(variantId, 1, {}, {
                  "success": function success(data, textStatus, jqXHR) {
                    console.log('Product added to cart successfully');
                    updateCartBubble();
                  },
                  "error": function error(jqXHR, textStatus, errorThrown) {
                    console.log('Error: ' + errorThrown + '!');
                  }
                });
                $(this).parent().find('.planCard__addToCart').hide();
                $(this).parent().find('.planCard__remove').hide();
                $(this).parent().find('.planCard__goToCart').show();
              });
            }
          }
        });
        timeoutCounter += 1;
        if (timeoutCounter > 100){
          clearInterval(wishlistLoaded);
        }
      }, 100);
      */
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }

    window.SwymCallbacks.push(swymCallbackFn);
    document.addEventListener("swym:collections-loaded", function () {
      window.SwymCallbacks.push(swymCallbackFn);
    });
  });
})(jQuery);
//Sleepify Starter Theme by Sleepless Media
//This file is intended to be used for small ongoing fixes or changes post-launch.
jQuery(document).ready(function ($) {
  // Simple accordion functionality
  $('.accordion__group button').on('click', function (e) {
    e.preventDefault(); // If item clicked on is open, close it

    if ($(this).closest('.accordion__group').hasClass('active')) {
      $(this).closest('.accordion__group').removeClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideUp();
    } else {
      // Otherwise, close all others and open the one clicked on
      $('.accordion__group').removeClass('active');
      $('.accordion__copy').slideUp();
      $(this).closest('.accordion__group').addClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideToggle();
    }
  });
});
jQuery(document).ready(function ($) {
  $('.customer--addresses .add-address').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
  $('.customer--addresses .add-address-cancel').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
});
jQuery(document).ready(function ($) {
  // Simple quantity box increase / decrease
  $('.js-qty:not(.js-qty--cart)').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }

    qtyInput.val(qtyInputVal);
  });
});
jQuery(document).ready(function ($) {
  // Make mobile category selector go to tag page
  $('.blog__tags select').on('change', function () {
    var tagUrl = $(this).val();
    window.location = tagUrl;
  });
});
jQuery(document).ready(function ($) {
  // PDP Options active class
  $('.pdp__options button').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.option__wrap').find('button').removeClass('active');
    $(this).addClass('active');
  });
});
jQuery(document).ready(function ($) {
  var _style = document.createElement('style');
  document.head.appendChild(_style);

  
  $('.alert-bar__slider')
    .on('init setPosition afterChange', function () {
      $(this).find('.slick-slide').each(function () {
        if ($(this).attr('aria-hidden') === 'true') {
          $(this).attr('tabindex', '-1').find('a, button, input, [tabindex]').attr('tabindex', '-1');
        } else {
          $(this).removeAttr('tabindex');
        }
      });
    })
    .slick({
    infinite: true,
      slidesToShow: 1,
    vertical: true,
    autoplay: true,
    dots: false,
    arrows: false,
    autoplaySpeed: 3500
  });
  headerOffset(); // Update offset on scroll

  $(window).on('scroll resize', function () {
    headerOffset();
  }); // Update offset on alert bar close

  $('.alert-bar .close--alert').on('click', function () {
    $('.alert-bar').remove();
    $('body').addClass('alert-closed');
    headerOffset();
  }); // Offset content from fixed header

  
  
  function updateMobileMenuRule() {
    var newValue = $('.fixed-wrap').innerHeight();
    var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();
    var scrolling = $('.fixed-wrap').hasClass('scrolling');

    if (scrolling){
      newValue -= newsHeight;
    }
    
    // If a rule is already there, remove it
    while (_style.sheet.cssRules.length > 0) {
      _style.sheet.deleteRule(0);
    }
    
    // Add the new rule
    _style.sheet.insertRule(
      `.header__mobileMenuButtonWrapper--open .header__slideInMobileMenu {
         max-height: calc(100dvh - ${newValue}px)!important;
       }`,
      0
    );
    _style.sheet.insertRule(
      `.slideInMenu__container {
         height: calc(100dvh - ${newValue}px)!important;
       }`,
      0
    );
    _style.sheet.insertRule(
      `.slideInMenu__shelf {
         height: calc(100dvh - ${newValue}px)!important;
       }`,
      0
    );
  }
  updateMobileMenuRule();
  
  function headerOffset() {
    var headerHeight = $('.fixed-wrap').innerHeight();
    $('#main').css('padding-top', headerHeight + 'px');
    updateMobileMenuRule();
    $(window).on('scroll resize', function () {
      var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();

      if ($(window).scrollTop() >= 350) {
        $('.fixed-wrap').addClass('scrolling');

        if (newsHeight != undefined) {
          $('.fixed-wrap').css('transform', 'translateY(-' + newsHeight + 'px)');
          $( '.mini-cart' ).css( 'top', newsHeight+'px' );
        }
      } else {
        $('.fixed-wrap').removeClass('scrolling');
        $('.fixed-wrap').css('transform', 'translateY(0)'); // $( '.mobile-menu' ).css( 'margin-top', '0' );
        $( '.mini-cart' ).css( 'top', '0px' );
      }
    });
  }
  headerOffset();

  $('.slideInMenu__goBack').on('click', function () {
    $(this).closest('.slideInMenu__shelfWrapper').removeClass('menuInnerOpen');
    document.activeElement.blur();
    $('.slideInMenu, .slideInMenu__shelfContainer, .slideInMenu__shelf').removeClass('noscroll');
  });
  $('.slideInMenu__childGoBack').on('click', function () {
    $(this).closest('.slideInMenu__shelfWrapper').find('.slideInMenu__linkButton').focus();
    $(this).closest('.slideInMenu__childShelfWrapper').removeClass('menuInnerOpen');
    $('.slideInMenu').scrollTop(0).addClass('noscroll');
    $('.slideInMenu__shelfContainer, .slideInMenu__shelf--parent').removeClass('noscroll');
  });
  $('.slideInMenu__grandChildGoBack').on('click', function () {
    $(this).closest('.slideInMenu__childShelfWrapper').find('.slideInMenu__childButton').focus();
    $(this).closest('.slideInMenu__grandChildShelfWrapper').removeClass('menuInnerOpen');

    $(this).closest('.slideInMenu__childShelfWrapper').removeClass('noscroll');
    $(this).closest('.slideInMenu__childShelfWrapper').find('.slideInMenu__shelf--child').removeClass('noscroll');
    $('.slideInMenu__shelfWrapper.menuInnerOpen .slideInMenu__shelf--parent').removeClass('noscroll');
    $('.slideInMenu').removeClass('noscroll');
    
    setTimeout(function(){
      
      $('.slideInMenu__shelfWrapper.menuInnerOpen .slideInMenu__shelf--parent').scrollTop(0);
      $('.slideInMenu').scrollTop(0);

      setTimeout(function(){
        $('.slideInMenu__shelfWrapper.menuInnerOpen .slideInMenu__shelf--parent').addClass('noscroll');
        $('.slideInMenu').addClass('noscroll');
        $(this).closest('.slideInMenu__childShelfWrapper').scrollTop(0);
        $(this).closest('.slideInMenu__childShelfWrapper').find('.slideInMenu__shelf--child').scrollTop(0);
      }, 2);
    }, 2);
    
    
    
  });

  $('.header__menuButton').on('click', function () {
    $('html').find('a, button, input').attr('tabindex', '0');
    $('.header__menuButtonWrapper').toggleClass('header__menuButtonWrapper--open');
  });
  
  $('.header__menuButtonWrapper').on('mouseout', function () {
    if (!$('.header__menuButtonWrapper').is(':hover')) {
      document.activeElement.blur();
      $('.header__menuButtonWrapper').removeClass('header__menuButtonWrapper--open');
    }
  });

  var scrollTopData = {
      top: 0,
      left: 0,
      behavior: "instant",
    }
  
  $('.slideInMenu__linkButton').on('click', function () {
    $(this).focus();
    $(this).parent().addClass('menuInnerOpen');
    $('.slideInMenu').scrollTop(0);
    $('.slideInMenu').addClass('noscroll');
  });

  $('.slideInMenu__childButton').on('click', function(){
    $(this).parent().addClass('menuInnerOpen');
    $('.slideInMenu__shelf').scrollTop(0);
    $('.slideInMenu__shelfContainer').scrollTop(0);
    $('.slideInMenu__shelf--parent').scrollTop(0);
    $(this).closest(' .slideInMenu__shelf--parent').addClass('noscroll');
    $(this).closest('.slideInMenu__shelfContainer').addClass('noscroll');
    
  });

  $('.slideInMenu__grandChildButton').on('click', function(){
    $(this).parent().addClass('menuInnerOpen');
    $('.slideInMenu__shelf').scrollTop(0);
    $('.slideInMenu__childShelfWrapper').scrollTop(0);
    $('.slideInMenu__shelf--child').scrollTop(0);
    $(this).closest(' .slideInMenu__childShelfWrapper').addClass('noscroll');
    $(this).closest(' .slideInMenu__shelf--child').addClass('noscroll');
  });
  
  $('.shopDrop__leftColumn').find('.shopDrop__categoryButton').first().addClass('shopDrop__categoryButton--first').addClass('shopDrop__categoryButton--active');
  $('.shopDrop__leftColumn').find('.shopDrop__categoryButton').last().addClass('shopDrop__categoryButton--last');
  $('.shopDrop__categoryCardInner').find('.shopDrop__categoryCardPackingListLink').first().addClass('shopDrop__categoryCardPackingListLink--first');
  $('.shopDrop__categoryCardInner').find('.shopDrop__categoryCardPackingListLink').last().addClass('shopDrop__categoryCardPackingListLink--last');
  $('.shopDrop__categoryCardInner').find('.shopDrop__categoryCardFlexLink').first().addClass('shopDrop__categoryCardFlexLink--first');
  $('.shopDrop__categoryCardInner').find('.shopDrop__categoryCardFlexLink').last().addClass('shopDrop__categoryCardFlexLink--last');
  $('.destinationDrop__leftColumn').find('.destinationDrop__categoryButton').first().addClass('destinationDrop__categoryButton--first').addClass('destinationDrop__categoryButton--active');
  $('.destinationDrop__leftColumn').find('.destinationDrop__categoryButton').last().addClass('destinationDrop__categoryButton--last');
  $('.destinationDrop__categoryCardFlex').find('.destinationDrop__categoryCardFlexLink').first().addClass('destinationDrop__categoryCardFlexLink--first');
  $('.destinationDrop__categoryCard').first().show();
  $('.header__megaMenuButton').keypress(function (e) {
    var target = $(this).parent();
    var key = e.which;

    if (key == 13) // enter key
      {
        $('html').find('a, button, input').attr('tabindex', '-1');
        target.find('.header__megaMenuDropDownContainer').find('button').attr('tabindex', '0');
        target.find('.header__megaMenuDropDownContainer').find('button').first().focus();
        return false;
      }
  });
  $('.shopDrop__categoryButton').keydown(function (e) {
    var thisThing = $(this);
    var key = e.which;

    if (key == 9) // tab key
      {
        if (thisThing.hasClass('shopDrop__categoryButton--last')) {
          thisThing.parent().find('.shopDrop__categoryButton--first').focus();
          e.preventDefault();
          return false;
        }
      } else if (key == 13) // enter key
      {
        thisThing.closest('.header__megaMenuWrapper').find('.shopDrop__categoryCard').hide();
        var target = thisThing.closest('.header__megaMenuWrapper').find('.shopDrop__categoryCard[data-index="' + thisThing.attr('data-index') + '"]');
        $('.shopDrop__categoryButton').removeClass('shopDrop__categoryButton--active');
        thisThing.addClass('shopDrop__categoryButton--active');
        target.show();
        $('html').find('a, button, input').attr('tabindex', '-1');
        target.find('a').attr('tabindex', '0');
        target.find('a').first().focus();
        return false;
      } else if (key == 27) // escape key
      {
        $('html').find('a, button, input').attr('tabindex', '0');
        $('.header__megaMenuDropDownContainer').find('button, a').attr('tabindex', '-1');
        thisThing.closest('.header__megaMenuWrapper').find('.header__megaMenuButton').focus();
        return false;
      }
  });
  $('.shopDrop__categoryCardFlexLink, .shopDrop__categoryCardPackingListLink').keydown(function (e) {
    var thisThing = $(this);
    var dataIndex = thisThing.closest('.shopDrop__categoryCard').attr('data-index');
    var key = e.which;

    if (key == 9) // tab key
      {
        if (thisThing.hasClass('shopDrop__categoryCardPackingListLink--last')) {
          console.log('test');
          thisThing.closest('.shopDrop__categoryCardPackingListFlex').find('.shopDrop__categoryCardPackingListLink--first').focus();
          e.preventDefault();
          return false;
        }
      } else if (key == 27) // escape key
      {
        $('html').find('a, button, input').attr('tabindex', '-1');
        thisThing.closest('.header__megaMenuDropDown').find('.shopDrop__categoryButton').attr('tabindex', '0');
        thisThing.closest('.header__megaMenuDropDown').find('.shopDrop__categoryButton[data-index="' + dataIndex + '"]').focus();
        return false;
      }
  });
  $('.shopDrop__categoryCardShopAll').keydown(function (e) {
    var thisThing = $(this);
    var dataIndex = thisThing.closest('.destinationDrop__categoryCard').attr('data-index');
    var key = e.which;

    if (key == 9) // tab key
      {
        thisThing.closest('.shopDrop__categoryCard').find('.shopDrop__categoryCardFlexLink--first').focus();
        e.preventDefault();
        return false;
      } else if (key == 27) // escape key
      {
        $('html').find('a, button, input').attr('tabindex', '-1');
        thisThing.closest('.header__megaMenuDropDown').find('.shopDrop__categoryButton').attr('tabindex', '0');
        thisThing.closest('.header__megaMenuDropDown').find('.shopDrop__categoryButton[data-index="' + dataIndex + '"]').focus();
        return false;
      }
  });
  $('.shopDrop__categoryButton').on('click', function () {
    $('html').find('a, button, input').attr('tabindex', '0');
    var thisThing = $(this);
    thisThing.focus();
    thisThing.closest('.header__megaMenuWrapper').find('.shopDrop__categoryCard').hide();
    var target = thisThing.closest('.header__megaMenuWrapper').find('.shopDrop__categoryCard[data-index="' + thisThing.attr('data-index') + '"]');
    $('.shopDrop__categoryButton').removeClass('shopDrop__categoryButton--active');
    thisThing.addClass('shopDrop__categoryButton--active');
    target.show();
  });
  $('.destinationDrop__categoryButton').keydown(function (e) {
    var thisThing = $(this);
    var key = e.which;

    if (key == 9) // tab key
      {
        if (thisThing.hasClass('destinationDrop__categoryButton--last')) {
          thisThing.parent().find('.destinationDrop__categoryButton--first').focus();
          e.preventDefault();
          return false;
        }
      } else if (key == 13) // enter key
      {
        thisThing.closest('.header__megaMenuWrapper').find('.destinationDrop__categoryCard').hide();
        var target = thisThing.closest('.header__megaMenuWrapper').find('.destinationDrop__categoryCard[data-index="' + thisThing.attr('data-index') + '"]');
        $('.destinationDrop__categoryButton').removeClass('destinationDrop__categoryButton--active');
        thisThing.addClass('destinationDrop__categoryButton--active');
        target.show();
        $('html').find('a, button, input').attr('tabindex', '-1');
        target.find('a').attr('tabindex', '0');
        target.find('a').first().focus();
        return false;
      } else if (key == 27) // escape key
      {
        $('html').find('a, button, input').attr('tabindex', '0');
        $('.header__megaMenuDropDownContainer').find('button, a').attr('tabindex', '-1');
        thisThing.closest('.header__megaMenuWrapper').find('.header__megaMenuButton').focus();
        return false;
      }
  });
  $('.destinationDrop__categoryButton').on('click', function () {
    $('html').find('a, button, input').attr('tabindex', '0');
    var thisThing = $(this);
    thisThing.focus();
    thisThing.closest('.header__megaMenuWrapper').find('.destinationDrop__categoryCard').hide();
    var target = thisThing.closest('.header__megaMenuWrapper').find('.destinationDrop__categoryCard[data-index="' + thisThing.attr('data-index') + '"]');
    $('.destinationDrop__categoryButton').removeClass('destinationDrop__categoryButton--active');
    thisThing.addClass('destinationDrop__categoryButton--active');
    target.show();
  });
  $('.destinationDrop__categoryCardFlexLink').keydown(function (e) {
    var thisThing = $(this);
    var dataIndex = thisThing.closest('.destinationDrop__categoryCard').attr('data-index');
    var key = e.which;

    if (key == 27) // escape key
      {
        $('html').find('a, button, input').attr('tabindex', '-1');
        thisThing.closest('.header__megaMenuDropDown').find('.destinationDrop__categoryButton').attr('tabindex', '0');
        thisThing.closest('.header__megaMenuDropDown').find('.destinationDrop__categoryButton[data-index="' + dataIndex + '"]').focus();
        return false;
      }
  });
  $('.destinationDrop__featuredCard').keydown(function (e) {
    var thisThing = $(this);
    var key = e.which;
    var dataIndex = thisThing.closest('.destinationDrop__categoryCard').attr('data-index');

    if (key == 9) // tab key
      {
        thisThing.closest('.destinationDrop__categoryCard').find('.destinationDrop__categoryCardFlexLink--first').focus();
        e.preventDefault();
        return false;
      } else if (key == 27) // escape key
      {
        $('html').find('a, button, input').attr('tabindex', '-1');
        thisThing.closest('.header__megaMenuDropDown').find('.destinationDrop__categoryButton').attr('tabindex', '0');
        thisThing.closest('.header__megaMenuDropDown').find('.destinationDrop__categoryButton[data-index="' + dataIndex + '"]').focus();
        return false;
      }
  });
  $('.header__mobileMenuButton').on('click', function () {
    $('html').find('a, button, input').attr('tabindex', '0');
    $(this).focus();

    if ($(this).parent().hasClass('header__mobileMenuButtonWrapper--open')) {
      $(this).parent().removeClass('header__mobileMenuButtonWrapper--open');
      $('html').removeClass('noscroll');
    } else {
      $(this).parent().addClass('header__mobileMenuButtonWrapper--open');
      $('html').addClass('noscroll');
    }
  });
});
jQuery(document).ready(function ($) {
  // Close mini cart
  $('.mini-cart__bg, .mini-cart__content .close').on('click', function () {
    closeMini();
  }); // Show mini cart

  $('.header__cartButton').on('click', function (e) {
    e.preventDefault();

    if (!$('body').hasClass('template__cart')) {
      showMini();
    } else {
      e.preventDefault();
    }
  }); // Mini Cart Remove Product

  $('.mini-cart').on('click', '.remove-product', function () {
    var lineNum = $(this).closest('.product').attr('data-lineid');
    $(this).closest('.product').addClass('removed');
    CartJS.removeItem(lineNum, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  }); // Mini Cart Upsell ATC

  $('.mini-cart__upsell .action--atc').on('click', function (e) {
    e.preventDefault();
    var dataId = $(this).closest('.upsell').attr('data-id');
    CartJS.addItem(dataId, 1, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  }); // Mini Cart Qty

  $('.mini-cart__list').on('click', '.js-qty--mini', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var lineData = $this.closest('.product').data('lineid');
    var lineNum = $('[data-lineID="' + lineData + '"]').index();

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }

    CartJS.updateItem(lineNum + 1, qtyInputVal, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  });
});

function closeMini() {
  $('html').removeClass('noscroll');
  $('.mini-cart').removeClass('is-open');
  $('.mini-cart').fadeOut('fast');
}

function showMini() {
  $('html').addClass('noscroll');
  $('.mini-cart').fadeIn('fast');
  $('.mini-cart').addClass('is-open'); // Set height of product list for full-height mini-cart
  // var miniHead = parseInt( $( '.mini-cart__header' ).innerHeight() );
  // var miniShip = parseInt( $( '.mini-cart__ship' ).innerHeight() );
  // var miniFooter = parseInt( $( '.mini-cart__footer' ).innerHeight() );
  // var miniUp = parseInt( $( '.mini-cart__upsell' ).innerHeight() );
  // var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp;
}

function refreshMiniCart(cartData) {
  var cartItems = cartData.items;
  var newCartHtml = ''; // Free shipping updater

  var totalShip = parseInt($('.mini-cart').data('freeship'));
  var newCartTotal = cartData.items_subtotal_price;
  var awayShip = totalShip - newCartTotal;
  var shipPercent = newCartTotal / totalShip * 100;

  if (shipPercent >= 100) {
    $('.shipping-bar--progress').css('width', '100%');
    $('.mini-cart__ship').addClass('is-free');
  } else {
    if ($('.mini-cart__ship').hasClass('is-free')) {
      $('.mini-cart__ship').removeClass('is-free');
    }

    $('.free-count').text(formatter.format(awayShip / 100));
    $('.shipping-bar--progress').css('width', shipPercent + '%');
  } // Build html of new products in cart


  $.each(cartItems, function (index, item) {
    // Opening
    newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="' + (index + 1) + '">';
    newCartHtml += ' <div class="product__image">';

    if (item.featured_image) {
      newCartHtml += '<a href="' + item.url + '">';
      newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_80x.jpg').replace('.png', '_80x.png') + '" srcset="' + item.featured_image.url.replace('.jpg', '_160x.jpg').replace('.png', '_160x.png') + ' 2x" alt="' + item.image.alt + '">';
      newCartHtml += '</a>';
    }

    newCartHtml += '</div>';
    newCartHtml += '<div class="product__info">';
    newCartHtml += '<div class="title d-flex">';
    newCartHtml += '<h3 class="heading--four d-flex justify-between">';
    newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
    newCartHtml += item.product_title;
    newCartHtml += '</a>';
    newCartHtml += ' <button class="remove-product trans"><span class="sr-only">Remove</span><img src="//cdn.shopify.com/s/files/1/0506/7037/0997/t/2/assets/icon-close.svg?v=18585775398919142161649090024" alt="" /></button>';
    newCartHtml += '</h3>';

    if (item.variant_options != null) {
      newCartHtml += '<span class="var">';
      $.each(item.variant_options, function (index, value) {
        if (value != 'Default Title') {
          if (index != 0) {
            newCartHtml += ' / ';
          }

          newCartHtml += value;
        }
      });
      newCartHtml += '</span>';
    }

    if (item.hasOwnProperty('selling_plan_allocation')) {
      newCartHtml += '<span class="delivery">' + item.selling_plan_allocation.selling_plan.name + '</span>';
    }

    newCartHtml += '<span class="unit-price">' + formatter.format(item.price / 100) + '</span>';
    newCartHtml += '</div>'; // newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>';

    newCartHtml += "<div class=\"actions d-flex align-center justify-between\">\n          <div class=\"action action--qty\">\n            <div class=\"qty d-flex align-center\">\n              <button class=\"js-qty js-qty--mini js-qty--minus trans\">\n                <span class=\"sr-only\">Decrease</span>\n              </button>\n              <input type=\"text\" value=\"" + item.quantity + "\" min=\"1\"  type=\"number\" class=\"qty-val\" />\n              <button class=\"js-qty js-qty--mini js-qty--plus trans\">\n                <span class=\"sr-only\">Increase</span>\n              </button>\n            </div>\n          </div>";
    newCartHtml += '<div class="price">' + formatter.format(item.final_line_price / 100) + '</div>';
    newCartHtml += '</div>'; // Closing

    newCartHtml += '</div>';
    newCartHtml += '</div>';
  }); // Clear current products in cart

  $('.mini-cart__items').empty(); // Set new subtotal

  $('.mini-cart__footer .sub-total .total').text(formatter.format(cartData.total_price / 100)); // Set new header icon count

  $('.icon--cart .cart-count span ').text(cartData.item_count);
  $('.mini-cartCount').text(cartData.item_count);
  console.log(cartData.item_count); // Add updated producst to mini cart

  $('.mini-cart__list').html(newCartHtml); // Show mini cart

  showMini();
}
jQuery(document).ready(function ($) {
  // Hero--full Slider
  $('.hero--full .hero__slider').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  }); // Hero--split Slider

  $('.hero--split .hero__slider').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    appendDots: '.hero--split .split--dots',
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  }); // Hero--split-flip Slider

  $('.hero--split-flip .hero__slider').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    appendDots: '.hero--split-flip .split--dots',
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  }); // PDP Default image slider

  $('.pdp__images--default .pdp__slider--thumb').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 5,
    vertical: true,
    focusOnSelect: true,
    asNavFor: '.pdp__images--default .pdp__slider--main',
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        vertical: false
      }
    }]
  });
  $('.pdp__images--default .pdp__slider--main').slick({
    infinite: true,
    fade: true,
    arrows: false,
    dots: false,
    asNavFor: '.pdp__images--default .pdp__slider--thumb'
  });

  $('.header__searchButton--mobile').on('click', function(){
    var searchQ = $('.header__searchInput--mobile').val();
    var cleaned = searchQ.replace(/ /g, '+');
    window.location.href = '/search?q='+cleaned;
  });
  
  $(".sizePop").detach().appendTo("body");
  
  $(".aboutVideoModal").detach().appendTo("body");

  $(".catToggleMob").detach().appendTo("body");
  if ($(window).width() < 767){
    $(".boost-pfs-filter-tree").detach().appendTo("body");
  }

  $('.slideInMenu__cartButton').on('click', function(){
    window.location.href = '/cart';
  });
  

  $('.prod__sizeChartButton').on('click', function(){
    $('.sizePop').fadeIn();
    //$('main').removeClass('main--3d');
  });

  $('.sizePop__bkg, .sizePop__close').on('click', function(){
    $('.sizePop').fadeOut();
    //$('main').addClass('main--3d');
  });

  if ($('.template__page--fishingReport').length > 0){
    var siteNumber = $('.reportFlow').attr('data-site-number');
    $.ajax({
      url: "https://waterservices.usgs.gov/nwis/iv/?format=json&sites="+siteNumber+"&parameterCd=00060&period=P14D",
      dataType: 'json',
      data: '',
      success: function(json){
        console.log(json.value);
        var flowData = json.value.timeSeries[0].values[0].value;
        console.log(flowData);
        
        var xData = [];
        var yData = [];
        for (i=0;i<flowData.length;i++){
          var thisDate = flowData[i].dateTime.split('T');
          var dateString = thisDate[0] + ' ' + thisDate[1];
          var thisValue = flowData[i].value * 1;
          xData.push(dateString);
          yData.push(thisValue);
          console.log(dateString);
          console.log(thisValue);
        }
        var graphData = [{
          x: xData,
          y: yData,
          type: 'scatter',
          mode: "lines",
          line: {color: '#FDAF15'},
          fill: 'tozeroy',
          fillcolor: 'rgba(253, 175, 21, .1)'
        }];
        var layout = {
          yaxis: {fixedrange: true},
          xaxis : {fixedrange: true}
        };
        
        console.log(graphData);
        Plotly.newPlot('reportFlow', graphData, layout);

        var latitude = json.value.timeSeries[0].sourceInfo.geoLocation.geogLocation.latitude;
        var longitude = json.value.timeSeries[0].sourceInfo.geoLocation.geogLocation.longitude;
        getWeatherData(latitude, longitude);
      },
      error : function(XMLHttpRequest, textStatus, errorThrown) {
         console.log('Error.');
        console.log(textStatus);
        console.log(errorThrown);
      }
    });

    function getWeatherData(latitude, longitude) {
      const url = `https://wttr.in/${latitude},${longitude}?format=j1`;
    
      $.ajax({
        url: url,
        type: "GET",
        dataType: "json",
        success: function(data) {
          console.log(data);
          var wind = data.weather[0].hourly[0].WindGustMiles;
          var temp = data.weather[0].hourly[0].tempF;
          var lowTemp = data.weather[0].mintempF;
          var highTemp = data.weather[0].maxtempF;

          $('.reportContent__value--wind').text(wind);
          $('.reportContent__value--temp').text(temp);
          $('.reportContent__value--low').text(lowTemp);
          $('.reportContent__value--high').text(highTemp);
        },
        error: function(err) {
          console.error("Error fetching weather data:", err);
        },
      });
    }

    $('.reportAccordion__head').on('click', function(){
      var parent = $(this).parent();
      if (parent.hasClass('reportAccordion--active')){
        parent.removeClass('reportAccordion--active');
        parent.find('.reportAccordion__rails').slideUp();
      }
      else{
        $('.reportAccordion').removeClass('reportAccordion--active');
        $('.reportAccordion').find('.reportAccordion__rails').slideUp();
        parent.addClass('reportAccordion--active');
        parent.find('.reportAccordion__rails').slideDown();
      }
      
    });
    
  }

  if ($('.template__collection').length > 0){
    setInterval(function(){
      if ($('#boost-pfs-quickview-cart-form').length > 0){
        var attr = $('#boost-pfs-quickview-cart-form').attr('action')
        if (typeof attr !== 'undefined' && attr !== false){
          $('#boost-pfs-quickview-cart-form').removeAttr('action').removeAttr('method').removeAttr('enctype');
        }
        if ($('#boost-pfs-quickview-cart-form').find('.boost-pfs-quickview-cart-btn').attr('id') == 'boost-pfs-quickview-cart-btn'){
          $('#boost-pfs-quickview-cart-form').find('.boost-pfs-quickview-cart-btn').attr('id', 'sleepless-pfs-quickview-cart-btn');

          $('#sleepless-pfs-quickview-cart-btn').on('click', function(e){
            e.preventDefault();
            var qty = $('#boost-pfs-quickview-cart-quantity').val();
            var variantID = $('#boost-pfs-quickview-variants-selector').val();
            CartJS.addItem(parseInt(variantID), parseInt(qty), {},
            {
              "success": function(data, textStatus, jqXHR) {
                //success state
                setTimeout( function( ) {
                  jQuery.getJSON('/cart.js', function(cart) {
                    refreshMiniCart(cart, parseInt(variantID), parseInt(qty));
                    $('.boost-pfs-quickview-close').click();
                  });
                }, 200 );
                // console.log( 'here-suc' )
              },
              "error": function(jqXHR, textStatus, errorThrown) {
                //error state
                console.log('Error: ' + errorThrown + '! - here');
              }
            });
          });
        }
      }
    },100 );
  }

  $('.reportSidebar__mobileSwapInput').on('change', function(){
    window.location.href = $(this).val();
  });

  $(".pdpImageModal").detach().appendTo("body");

  $('.prodGallery__magGlass').on('click', function(){
    var imageSrc = $('.prodGallery__mainContainer .swiper-slide-active .prodGallery__mainImg').attr('src');
    $('.pdpImageModal__image').attr('src', imageSrc);
    $('.pdpImageModal').fadeIn();
  });

  $('.pdpImageModal__bkg, .pdpImageModal__close').on('click', function(){
    $('.pdpImageModal').fadeOut();
  });

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkProductCount() {
    let prodCount = getCookie("product-count");
    if (prodCount != "") {
     
    } else {
      username = prompt("Please enter your name:", "");
      if (username != "" && username != null) {
        setCookie("username", username, 365);
      }
    }
  }

  function formatMoneyRecent(money){
    let amountInCents = money;
    let amountInDollars = parseInt(amountInCents, 10) / 100;
    let formattedAmount = "$" + amountInDollars.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});
    return formattedAmount;
  }

  function populateRecent(prodArray, currentProd){
    var recentProdData = [];
    for (i=0;i<prodArray.length;i++){
      if (prodArray[i] != currentProd){
          jQuery.getJSON(window.Shopify.routes.root + 'products/'+prodArray[i]+'.js', function(product) {
          recentProdData.push(product);
        } );
      }
      else{
        recentProdData.push({id:false});
      }
    }
    var checkResponses = setInterval(function(){
      if (prodArray.length == recentProdData.length){
        console.log(recentProdData);

        var counter = 0;

        for (j=0;j<recentProdData.length;j++){
          if (recentProdData[j].id != false){
            var data = recentProdData[j];
            var target = $('.prodRelated .prodCard--' + counter);
            target.attr('data-available', data.available);
            target.attr('data-id', data.id);
            target.attr('data-variantid', data.variants[0].id);

            target.find('.plProdCard__imgLink').attr('href', data.url).removeAttr('aria-disabled tabindex');
            target.find('.plProdCard__img').attr('src', data.featured_image);
            target.find('.plProdCard__img').attr('alt', data.title);
            target.find('.plProdCard__img').attr('data-original', data.featured_image);
            if (data.images.length > 1){
              target.find('.plProdCard__img').attr('data-swap', data.images[1]);
            }
            else{
              target.find('.plProdCard__img').attr('data-swap', data.featured_image);
            }

            if (data.price < data.compare_at_price){
              target.find('.plProdCard__saleTag').show();
              target.find('.plProdCard__oldPrice').show();
              target.find('.plProdCard__oldPrice').text(formatMoneyRecent(data.compare_at_price));
            }
            else{
              target.find('.plProdCard__saleTag').hide();
              target.find('.plProdCard__oldPrice').hide();
            }

            if (data.available === true){
              target.find('.plProdCard__buyWrapper').show();
              target.find('.plProdCard__soldOutWrapper').hide();
            }
            else{
              target.find('.plProdCard__buyWrapper').hide();
              target.find('.plProdCard__soldOutWrapper').show();
            }

            target.find('.plProdCard__title').text(data.title);
            target.find('.plProdCard__brandCat').text(data.vendor);
            target.find('.plProdCard__title').attr('href', data.url).removeAttr('aria-disabled tabindex');
            target.find('.plProdCard__addToCartFalse').attr('href', data.url).removeAttr('aria-disabled tabindex');

            target.find('.plProdCard__price').text(formatMoneyRecent(data.price));

            //swatches
            var swatchList = [];
            var colorList = [];
            var colorOption = -1;
            if (data.options.length > 0){
              for (k=0; k<data.options.length; k++){
                if (data.options[k].name == "Color"){
                  colorOption = k;
                }
              }
            }
            
            console.log('color option: '+colorOption);
            if (colorOption != -1){
              for (k=0; k<data.variants.length; k++){
                var thisVar = data.variants[k];
                var thisColor = thisVar.options[colorOption];
                if (thisVar.featured_image != null){
                  if (!colorList.includes(thisColor)){
                    colorList.push(thisColor);
                    swatchList.push({
                      name: thisColor,
                      image: thisVar.featured_image.src.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png'),
                      thumb: thisVar.featured_image.src.replace('.jpg', '_100x.jpg').replace('.png', '_100x.png')
                    });
                  }
                }
                
              }

              console.log(swatchList);
              
              var swatchHtml = '';

              for (k=0; k< swatchList.length; k++){
                var thisObject = swatchList[k];
                if (k < 4){
                  if (k == 0){
                    swatchHtml += '<button class="plProdCard__swatch plProdCard__swatch--active" data-swap-image="' + thisObject.image + '">';
                  }
                  else{
                    swatchHtml += '<button class="plProdCard__swatch" data-swap-image="' + thisObject.image + '">';
                  }

                  swatchHtml += '<img class="plProdCard__swatchImage" src="'+thisObject.thumb+'" alt="'+thisObject.name+'">';
                  swatchHtml += '</button>';
                }
                if (k == 4){
                  swatchHtml += '<div class="plProdCard__swatchMore">+'+(swatchList.length - 4)+'</div>'
                }
              }

              target.find('.plProdCard__swatchFlex').html(swatchHtml);

              target.find('.plProdCard__swatch').each(function(){
                var newImage = $(this).attr('data-swap-image');
                var img=new Image();
                img.src=newImage;
              });
              target.find('.plProdCard__swatch').on('click', function(){
                var newImage = $(this).attr('data-swap-image');
                $(this).closest('.plProdCard__inner').find('.plProdCard__img').attr('src', newImage);
              });

              
            }
            //endswatches

            counter += 1;
          }
        }
        
        clearInterval(checkResponses);

        var targetSlider = '.prodRelated--recent .prodRecent__sliderWrapper';
        var targetNext = '.prodRelated--recent .plCategory__sliderNext';
        var targetPrev = '.prodRelated--recent .plCategory__sliderPrev';
        var targetScrollbar = '.prodRelated--recent .plCategory__sliderScrollContainer';
        var recentSlider = new Swiper(targetSlider, {
          slidesPerView: 1,
          shortSwipes: false,
          threshold: 8,
          freeMode: {
            enabled: true,
            sticky: true
          },
          mousewheel: {
            enabled: true,
            forceToAxis: true
          },
          loop: false,
          spaceBetween: 30,
          navigation: {
            nextEl: targetNext,
            prevEl: targetPrev,
            disabledClass: 'plCategory__sliderButton--disabled'
          },
          scrollbar: {
            el: targetScrollbar,
            draggable: true
          },
          breakpoints: {
            // when window width is >= 1000px
            1001: {
              slidesPerView: 4,
              shortSwipes: false
            },
            1000: {
              slidesPerView: 3,
              shortSwipes: false
            },
            800: {
              slidesPerView: 2,
              shortSwipes: false
            }
          }
        });
      }
    }, 10);
  }

  if ($('.prodHandleHolder').length > 0){
    console.log(getCookie('product-count'));
    if (getCookie('product-count') != ''){
      
      var prodCount = getCookie('product-count') * 1;
      if (prodCount < 5){
        var cookieArray = getCookie("product-array");
        var prodHandle = $('.prodHandleHolder').attr('data-handle');
        if (!cookieArray.includes(prodHandle)){
          var newString = prodHandle + '|' + cookieArray;
          setCookie("product-array", newString, 365);
          var newCount = prodCount + 1;
          setCookie("product-count", newCount, 365);
        }
        if (cookieArray.split('|').length > 3){
          populateRecent(cookieArray.split('|'), prodHandle);
        }
        else{
          $('.prodRelated--recent').hide();
        }
        
      }
      else{
        var cookieStringInitial = getCookie("product-array");
        var cookieArray = getCookie("product-array").split('|');
        var prodHandle = $('.prodHandleHolder').attr('data-handle');

        if (!cookieStringInitial.includes(prodHandle)){
          var popped = cookieArray.pop();
          var cookieString = cookieArray.join('|');
          var newString = prodHandle + '|' + cookieString;
          setCookie("product-array", newString, 365);
        }

        if (cookieArray.length > 3){
          populateRecent(cookieArray, prodHandle);
        }
        
      }
      
    }
    else{
      setCookie("product-count", "1", 365);
      setCookie("product-array", $('.prodHandleHolder').attr('data-handle'), 365);
    }
  }

  var lodgeVideoSlider = new Swiper('.lodgeVideos__sliderWrapper', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: false,
      threshold: 15,
      navigation: {
        nextEl: '.lodgeVideos__sliderNext',
        prevEl: '.lodgeVideos__sliderPrev',
        disabledClass: 'lodgeVideos__sliderButton--disabled'
      },
      breakpoints: {
        // when window width is >= 1000px
        1000: {
          slidesPerView: 4
        },
        700: {
          slidesPerView: 2
        }
      }
    });

  $('.lodgeVideos__slideInner').on('click', function () {
    $('.lodgeVideoModal').fadeIn();
    $('.lodgeVideoModal__iframeWrapper').html($(this).attr('data-iframe'));
  });

  $('.lodgeTab__textInner').find('iframe').wrap('<div class="responsiveIframeInner"></div>');

  var homeCollectionSlider = new Swiper('.plCategory__sliderWrapper--home', {
    slidesPerView: 1,
    shortSwipes: true,
    loop: false,
    spaceBetween: 30,
    navigation: {
      nextEl: '.plCategory__sliderNextArrow',
      prevEl: '.plCategory__sliderPrevArrow',
      disabledClass: 'plCategory__sliderButton--disabled'
    },
    breakpoints: {
      1000: {
        slidesPerView: 4,
        shortSwipes: false
      },
      800: {
        slidesPerView: 3,
        shortSwipes: false
      },
      600: {
        slidesPerView: 2,
        shortSwipes: false
      }
    }
  });

  var tiesCollectionSlider = new Swiper('.plCategory__sliderWrapper--ties', {
    slidesPerView: 1,
    shortSwipes: true,
    loop: false,
    spaceBetween: 30,
    navigation: {
      nextEl: '.plCategory__sliderNextArrow',
      prevEl: '.plCategory__sliderPrevArrow',
      disabledClass: 'plCategory__sliderButton--disabled'
    },
    breakpoints: {
      1000: {
        slidesPerView: 4,
        shortSwipes: false
      },
      800: {
        slidesPerView: 3,
        shortSwipes: false
      },
      600: {
        slidesPerView: 2,
        shortSwipes: false
      }
    }
  });

  
  var catBar = $('.plCategories__catBar').prop("outerHTML");
  $('#shopify-section-plDescription').after(catBar);
  $('#shopify-section-affiliateCollectionDescription').after(catBar);
  $('#shopify-section-plCategories').find('.plCategories__catBar').hide();
  if ($('.template__collection--affiliate').length > 0){
    $('.plCategories__catBar').addClass('plCategories__catBar--affiliate');

    $(window).scroll(function(){
      var fixed = $(".affHeader__bottomLogoContainer");
      var toCross = $('.plCategories__catBar');
      
      var fixed_position = fixed.offset().top;
      var fixed_height = 90;
    
      var toCross_position = toCross.offset().top;
      var toCross_height = toCross.height();
    
      if (fixed_position + fixed_height  < toCross_position) {
        toCross.removeClass('plCategories__catBar--stuck');
      } else if (fixed_position > toCross_position + toCross_height) {
        toCross.removeClass('plCategories__catBar--stuck');
      } else {
        toCross.addClass('plCategories__catBar--stuck');
      }
    
    });
  }

  $('.plCategories__tab').on('click', function () {
      if (!$(this).hasClass('plCategories__tab--active')) {
        var target = $('.plCategory[data-index="' + $(this).attr('data-index') + '"]');
        $('.plCategory').slideUp();
        target.slideDown();
        $('.plCategories__tab').removeClass('plCategories__tab--active');
        $(this).addClass('plCategories__tab--active');
      }
    });

    $('.plCategories__mobileSelector').on('change', function(){
      var target = $('.plCategory[data-index="' + $(this).val() + '"]');
        $('.plCategory').slideUp();
        target.slideDown();
    });

  $('.header__megaMenuWrapper--destination .destinationDrop__categoryCard[data-index="12"]').find('.destinationDrop__categoryCardFlexColumn').first().attr('style', 'width:max-content;');
  $('.header__megaMenuWrapper--destination .destinationDrop__categoryCard[data-index="13"]').find('.destinationDrop__categoryCardFlexColumn').first().attr('style', 'width:max-content;');
  $('.header__megaMenuWrapper--destination .destinationDrop__categoryCard[data-index="14"]').find('.destinationDrop__categoryCardFlexColumn').first().attr('style', 'width:max-content;');
  $('.header__megaMenuWrapper--destination .destinationDrop__categoryCard[data-index="14"]').find('.destinationDrop__categoryCardFlexColumn').first().find('.destinationDrop__categoryCardFlexColumnFlex').first().attr('style', 'width:auto;');

  $('.prodGallery__mainImgWrapper').each(function() {
    var $wrapper = $(this);
    var $img = $wrapper.find('.prodGallery__mainImg');
    var isZoomed = false;
    var scale = 2; // fixed zoom factor

    // Helper: update the transform based on fraction
    // fractionX = 0 => show left edge
    // fractionX = 1 => show right edge
    // fractionY = 0 => show top edge
    // fractionY = 1 => show bottom edge
    function updateTransform(fractionX, fractionY) {
      // Wrapper's width/height
      var wWidth = $wrapper.width();
      var wHeight = $wrapper.height();

      // The image is scaled by "scale".
      // Extra width = (scale - 1) * wWidth
      // Extra height = (scale - 1) * wHeight
      // If fractionX = 0 => offsetX = 0 (left edge aligned)
      // If fractionX = 1 => offsetX = -extraWidth (right edge aligned)
      var offsetX = -(fractionX * (scale - 1) * wWidth);
      var offsetY = -(fractionY * (scale - 1) * wHeight);

      // Apply translate + scale
      $img.css('transform', 
        'translate(' + offsetX + 'px,' + offsetY + 'px) scale(' + scale + ')'
      );
    }

    // Zoom out function (shared by second click & mouseleave)
    function zoomOut() {
      $img.removeClass('zoomed');
      // Reset transform to no scale / no offset
      $img.css('transform', 'translate(0,0) scale(1)');
      isZoomed = false;
    }

    // 1) CLICK => Toggle zoom
    $wrapper.on('click', function(e) {
      if (!isZoomed) {
        isZoomed = true;
        $img.addClass('zoomed');

        // Figure out where in the wrapper the user clicked, as fraction [0..1]
        var wrapperOffset = $wrapper.offset();
        var clickX = e.pageX - wrapperOffset.left;
        var clickY = e.pageY - wrapperOffset.top;
        var fractionX = clickX / $wrapper.width();
        var fractionY = clickY / $wrapper.height();

        // Immediately position the image so that the clicked point is
        // aligned with the corresponding fraction in the zoomed image.
        updateTransform(fractionX, fractionY);

      } else {
        // If already zoomed, clicking again => zoom out
        zoomOut();
      }
    });

    // 2) MOUSEMOVE => update transform if zoomed
    $wrapper.on('mousemove', function(e) {
      if (isZoomed) {
        var wrapperOffset = $wrapper.offset();
        var mouseX = e.pageX - wrapperOffset.left;
        var mouseY = e.pageY - wrapperOffset.top;

        // Keep them within [0..1], in case the mouse is near edges
        var fractionX = mouseX / $wrapper.width();
        var fractionY = mouseY / $wrapper.height();

        // Constrain fraction to 0..1 just in case
        if (fractionX < 0) fractionX = 0;
        if (fractionX > 1) fractionX = 1;
        if (fractionY < 0) fractionY = 0;
        if (fractionY > 1) fractionY = 1;

        updateTransform(fractionX, fractionY);
      }
    });

    // 3) MOUSELEAVE => zoom out if currently zoomed
    $wrapper.on('mouseleave', function() {
      if (isZoomed) {
        zoomOut();
      }
    });
  });

  var homeAdventureSwiper = new Swiper('.homeAdventure__sliderWrapper', {
    slidesPerView: 1,
    shortSwipes: false,
    threshold: 8,
    freeMode: {
      enabled: true,
      sticky: true
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true
    },
    loop: false,
    spaceBetween: 30,
    navigation: {
      nextEl: '.homeAdventure__navButton--next',
      prevEl: '.homeAdventure__navButton--prev',
      disabledClass: 'homeAdventure__navButton--disabled'
    },
    scrollbar: {
      el: '.homeAdventure__navBar',
      draggable: true
    },
    breakpoints: {
      // when window width is >= 1000px
      1000: {
        slidesPerView: 3
      },
      800: {
        slidesPerView: 2
      }
    }
  });

  var homeRegionSwipers = [];

  $('.homeRegions__swiperDrawer').each(function(){
    var thisRegion = $(this).attr('data-region');
    var tempSlide = new Swiper('.homeRegions__swiperDrawer[data-region="'+thisRegion+'"] .homeRegions__swiperWrapper', {
    slidesPerView: 1,
    shortSwipes: false,
    threshold: 8,
    freeMode: {
      enabled: true,
      sticky: true
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true
    },
    loop: false,
    spaceBetween: 30,
    navigation: {
      nextEl: '.homeRegions__swiperDrawer[data-region="'+thisRegion+'"] .homeRegions__navButton--next',
      prevEl: '.homeRegions__swiperDrawer[data-region="'+thisRegion+'"] .homeRegions__navButton--prev',
      disabledClass: 'homeRegions__navButton--disabled'
    },
    scrollbar: {
      el: '.homeRegions__swiperDrawer[data-region="'+thisRegion+'"] .homeRegions__navBar',
      draggable: true
    },
    breakpoints: {
      // when window width is >= 1000px
      1000: {
        slidesPerView: 3
      },
      800: {
        slidesPerView: 2
      }
    }
  });
  });

  var homeFilmSwiper = new Swiper('.homeFilm__sliderWrapper', {
    slidesPerView: 1,
    shortSwipes: false,
    centeredSlides: true,
    watchSlidesProgress: true,
    slideFullyVisibleClass: 'homeFilmCard--visible',
    threshold: 8,
    freeMode: {
      enabled: true,
      sticky: true
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true
    },
    loop: true,
    spaceBetween: 30,
    navigation: {
      nextEl: '.homeFilm__navButton--next',
      prevEl: '.homeFilm__navButton--prev',
      disabledClass: 'homeFilm__navButton--disabled'
    },
    scrollbar: {
      el: '.homeFilm__navBar',
      draggable: true
    },
    breakpoints: {
      // when window width is >= 1000px
      1000: {
        slidesPerView: 3
      }
    }
  });

  $('.homeRegions__swiperDrawer').hide();
  $('.homeRegions__swiperDrawer--active').show();

  $('.homeRegions__regionButton').on('click', function(){
    if ($(this).hasClass('homeRegions__regionButton--active') == false){
      $('.homeRegions__regionButton--active').removeClass('homeRegions__regionButton--active');
      $(this).addClass('homeRegions__regionButton--active');
      var region = $(this).attr('data-region');
      $('.homeRegions__swiperDrawer--active').hide();
      $('.homeRegions__swiperDrawer--active').removeClass('homeRegions__swiperDrawer--active');
      $('.homeRegions__swiperDrawer[data-region="'+region+'"]').addClass('homeRegions__swiperDrawer--active');
      $('.homeRegions__swiperDrawer[data-region="'+region+'"]').show();
    }
  });

  $('.homeFilmCard__playButton').on('click', function(){
      var videoSrc = $(this).attr('data-video-src');
      var videoStyle = $(this).attr('data-video-style');
      $('.homeFilmModal').fadeIn(400);
      $('.homeFilmModal').find('iframe').attr('src', videoSrc);
      $('.homeFilmModal').find('iframe').attr('style', videoStyle);
    $('html').addClass('noscroll');
    $('main').removeClass('main--3d');
  });

  $('.homeFilmModal__background, .homeFilmModal__close').on('click', function(){
    if ($('.homeFilmModal').is(':visible')){
      $('.homeFilmModal').fadeOut(400, function(){
        $('main').addClass('main--3d');
        $('.homeFilmModal').find('iframe').attr('src', '');
        $('.homeFilmModal').find('iframe').attr('style', '');
        $('html').removeClass('noscroll');
      });
    }
  });

  $('.dayTrip__selector').on('change', function(){
    if ($(this).hasClass('dayTrip__selector--category')){
      $('.dayTrip__selector--filter').html('');
      var thisCat = $('.dayTrip__selector--category').val();
      for (var i=0;i<tripCategories.length;i++){
        var currentCat = tripCategories[i];
        if (currentCat.category == thisCat){
          $('.dayTrip__selector--filter').append('<option value="null" selected disabled>Pick a Filter</option>');
          var currentFiltersArray = currentCat.filters.split(', ');
          for (var j=0;j<currentFiltersArray.length;j++){
            $('.dayTrip__selector--filter').append('<option value="'+ currentFiltersArray[j] +'">'+ currentFiltersArray[j] +'</option>');
          }
        }
      }
    }
    $('.teamSection__reset').show();
    onGuidesFiltered();
  });

  $('.teamSection__reset').on('click', function(){
    $('.dayTrip__selector--category').val('null');
    $('.dayTrip__selector--filter').val('null');
    onGuidesFiltered();
  });

  $('.plLandingDesk__readMore').on('click', function(){
    $('.plLandingDesc__text--long').removeClass('plLandingDesc__text--long');
    $(this).hide();
  });

  function getFilteredGuides(guides){
    console.log(guides);
    var thisCat = String($('.dayTrip__selector--category').val());
    var thisFilter = String($('.dayTrip__selector--filter').val());
    var returnArray = [];
    console.log(thisCat);
    console.log(thisFilter);
    for (i = 0;i<guides.length;i++){
      if (thisCat === "null" && thisFilter === "null"){
        returnArray.push(guides[i]);
      }
      else{
        var thisCatArray = guides[i].categories.split(', ');
        var thisFilterArray = guides[i].filters.split(', ');
        if (thisCatArray.includes(thisCat)){
          if (thisFilter === "null" || thisFilterArray.includes(thisFilter)){
            returnArray.push(guides[i]);
          }
        }
      }
    }
    return returnArray;
  }

  function getPaginateGuides(guides, pageIndex = 0){
    var guidesPerPage = 20;
    var returnArray = [];
    for (i = 0;i<guides.length;i++){
      if (i >= (guidesPerPage * pageIndex) && i < ((guidesPerPage * pageIndex) + guidesPerPage)){
        returnArray.push(guides[i]);
      }
    }
    return returnArray;
  }

  function onGuidesFiltered(){
    var filteredGuides = getFilteredGuides(dayTrips);
    var paginatedFiltered = getPaginateGuides(filteredGuides, 0);
    renderPaginatedGuides(paginatedFiltered);
    setPaginationNumbers(filteredGuides);
    $('.dayTrips__number').removeClass('dayTrips__number--active');
    $('.dayTrips__number').first().addClass('dayTrips__number--active');
    $('.dayTrips__previous').addClass('dayTrips__previous--disabled');
    $('.dayTrips__next').removeClass('dayTrips__previous--disabled');
  }

  function setPaginationNumbers(allGuides){
    $('.dayTrips__pageFlex').html('<button class="dayTrips__number dayTrips__number--active" data-index="1">1</button>');
    var pages = Math.floor(allGuides.length / 20) + 1;
    if ((allGuides.length % 20) == 0){  
      pages = allGuides.length / 20;
    }

    if (pages > 1){
      for (i=1; i<pages; i++){
        $('.dayTrips__pageFlex').append('<button class="dayTrips__number" data-index="'+((i * 1) + 1)+'">'+((i * 1) + 1)+'</button>');
      }
    }

    $('.dayTrips__number').on('click', function(){
      var thisPage = $(this).attr('data-index') * 1;
      if (!$(this).hasClass('dayTrips__number--active')){
        $('.dayTrips__number').removeClass('dayTrips__number--active');
        $('.teamSection--dayTrip').attr('data-page', thisPage);
        var filteredGuides = getFilteredGuides(dayTrips);
        var paginatedFiltered = getPaginateGuides(filteredGuides, (thisPage - 1));
        renderPaginatedGuides(paginatedFiltered);
        $(this).addClass('dayTrips__number--active');
        if (thisPage > 1){
          $('.dayTrips__previous').removeClass('dayTrips__previous--disabled');
        }
        else{
          $('.dayTrips__previous').addClass('dayTrips__previous--disabled');
        }
        var lastPage = $('.dayTrips__number').last().attr('data-index') * 1;
        if (thisPage == lastPage){
          $('.dayTrips__next').addClass('dayTrips__previous--disabled');
        }
        else{
          $('.dayTrips__next').removeClass('dayTrips__previous--disabled');
        }
      }
    });
  }

  function renderPaginatedGuides(guides){
    var loopIndex = 0;
    $('.teamMember--paginated').hide();
    $('.teamMember--paginated').each(function(){
      if (guides[loopIndex]){
        thisGuide = guides[loopIndex];
        $(this).attr('data-img', thisGuide.image);
        $(this).attr('data-title', thisGuide.name);
        $(this).attr('data-sub', thisGuide.subtitle);
        $(this).attr('data-text', thisGuide.text);
        $(this).attr('data-href', thisGuide.href);
        $(this).attr('data-handle', thisGuide.handle);

        $(this).find('.teamMember__img').attr('src', thisGuide.image);
        $(this).find('.teamMember__img').attr('alt', thisGuide.name);
        $(this).find('.teamMember__name').text(thisGuide.name);

        $(this).show();
      }
      
      loopIndex += 1;
    });
  }

  if ($('.teamSection--dayTrip').length > 0){
    setPaginationNumbers(dayTrips);
    var initialGuides = getPaginateGuides(dayTrips, 0);
    renderPaginatedGuides(initialGuides);
    $('.teamSection--dayTrip').attr('data-page', 1);
  };

  $('.dayTrips__next').on('click', function(){
    var currentPage = $('.dayTrips__number--active').attr('data-index') * 1;
    var thisPage = (currentPage * 1) + 1;
    if (!$(this).hasClass('dayTrips__next--disabled')){
      $('.dayTrips__number').removeClass('dayTrips__number--active');
      $('.teamSection--dayTrip').attr('data-page', thisPage);
      var filteredGuides = getFilteredGuides(dayTrips);
      var paginatedFiltered = getPaginateGuides(filteredGuides, (thisPage - 1));
      renderPaginatedGuides(paginatedFiltered);
      $('.dayTrips__number[data-index="'+thisPage+'"]').addClass('dayTrips__number--active');
      if (thisPage > 1){
        $('.dayTrips__previous').removeClass('dayTrips__previous--disabled');
      }
      else{
        $('.dayTrips__previous').addClass('dayTrips__previous--disabled');
      }
      var lastPage = $('.dayTrips__number').last().attr('data-index') * 1;
      if (thisPage == lastPage){
        $('.dayTrips__next').addClass('dayTrips__previous--disabled');
      }
      else{
        $('.dayTrips__next').removeClass('dayTrips__previous--disabled');
      }
    }
  });

  $('.dayTrips__previous').on('click', function(){
    var currentPage = $('.dayTrips__number--active').attr('data-index') * 1;
    var thisPage = (currentPage * 1) - 1;
    if (!$(this).hasClass('dayTrips__previous--disabled')){
      $('.dayTrips__number').removeClass('dayTrips__number--active');
      $('.teamSection--dayTrip').attr('data-page', thisPage);
      var filteredGuides = getFilteredGuides(dayTrips);
      var paginatedFiltered = getPaginateGuides(filteredGuides, (thisPage - 1));
      renderPaginatedGuides(paginatedFiltered);
      $('.dayTrips__number[data-index="'+thisPage+'"]').addClass('dayTrips__number--active');
      if (thisPage > 1){
        $('.dayTrips__previous').removeClass('dayTrips__previous--disabled');
      }
      else{
        $('.dayTrips__previous').addClass('dayTrips__previous--disabled');
      }
      var lastPage = $('.dayTrips__number').last().attr('data-index') * 1;
      if (thisPage == lastPage){
        $('.dayTrips__next').addClass('dayTrips__previous--disabled');
      }
      else{
        $('.dayTrips__next').removeClass('dayTrips__previous--disabled');
      }
    }
  });

  if ($('.plCategories__catBar').length > 0){
    $('body').attr('style', 'overflow-x:initial!important;');
  }

  $('.prodInvite__buyButton').on('click', function(){
    $('[sm-rc-add-to-cart]').first().click();
  });

  if ($('.prodComp').length > 0){
    $('.plProdCard__swatch').each(function(){
      var newImage = $(this).attr('data-swap-image');
      var img=new Image();
      img.src=newImage;
    });
    $('.plProdCard__swatch').on('click', function(){
      var newImage = $(this).attr('data-swap-image');
      $(this).closest('.plProdCard__inner').find('.plProdCard__img').attr('src', newImage);
    });
  }

  $('.plCategory__accordionHead').on('click', function(){
    var target = $(this).parent().find('.plCategory__flex');
    if ($(this).hasClass('plCategory__accordionHead--open')){
      $(this).parent().find('.plCategory__flex').slideUp();
      $(this).removeClass('plCategory__accordionHead--open')
    }
    else{
      $(this).parent().find('.plCategory__flex').slideDown();
      $(this).addClass('plCategory__accordionHead--open')
    }
  });

  $('.header__mobileMenuSearchButton').on('click', function(){
    $('.slideInMenu__searchWrapper').slideToggle();
  });

  
});